import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  TextField,
  CircularProgress,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import './index.css';  // your custom styles (optional)
import { IconButton, Tooltip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import GridView from './GridView';
import './games.css';  // your custom styles (optional)
import loadingSpriteSonic from './assets/loading/sonic.gif';
import loadingSpriteMario64 from './assets/loading/mario64.gif';
import loadingSpriteSMW from './assets/loading/smw.gif';
import loadingSpritePac from './assets/loading/pac.gif';
import loadingSpritePika from './assets/loading/pika.gif';
import loadingSpriteAku from './assets/loading/aku.gif';
import loadingSpriteTerry from './assets/loading/terry.gif';
import loadingSpriteGhost from './assets/loading/ghosts.gif';
import loadingSpriteTails from './assets/loading/tails.gif';
import loadingSpriteWario from './assets/loading/wario.gif';
import {
  ACTIVE_CONTROLLER_SFX_COLLECTION_KEY,
  createControllerSoundSet,
  playControllerSoundFromSet,
  warmControllerSounds,
  resolvePlatformSfxCollectionKey,
} from './controllerSfx';

<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"></link>


const REACT_APP_API_URL = 'https://gamecollection-app.onrender.com/api';
//const REACT_APP_API_URL = 'http://127.0.0.1:8000/api';
const REACT_APP_URL = 'https://gamecollection-app.onrender.com';
const CONTROLLER_REPEAT_INITIAL_DELAY_MS = 240;
const CONTROLLER_REPEAT_INTERVAL_MS = 60;
const LARGE_LIST_SNAPPY_THRESHOLD = 150;
const LARGE_LIST_REPEAT_INITIAL_DELAY_MS = 120;
const LARGE_LIST_REPEAT_INTERVAL_MS = 36;
//const REACT_APP_URL = 'http://127.0.0.1:8000';
const PLATFORM_TO_GAMES_TRANSITION_KEY = 'transition:platform-to-games';
const GAMES_TO_PLATFORMS_TRANSITION_KEY = 'transition:games-to-platforms';
const CONTROLLER_CONNECTED_STATE_KEY = 'controller:connected-active';
const RETURN_FROM_LAUNCH_FOCUS_KEY = 'games:return-from-launch-focus';
const LOCAL_LAUNCHER_URL = 'http://127.0.0.1:17342';
const LOADING_SPRITE_IMAGES = [
  loadingSpriteSonic,
  loadingSpriteMario64,
  loadingSpriteSMW,
  loadingSpritePac,
  loadingSpritePika,
  loadingSpriteTails,
  loadingSpriteWario,
  // Add more sprite images here (imported files or URLs)
];
const LOADING_SPRITE_SPEEDS = [
1,
1,
3,
2.5,
2,
1.3,
2.5
  // Add/remove walk durations in seconds
];

const createRandomLoadingSprite = () => {
const imageIndex = Math.floor(Math.random() * LOADING_SPRITE_IMAGES.length);
return {
  image: LOADING_SPRITE_IMAGES[imageIndex] || loadingSpriteSonic,
  durationSeconds: LOADING_SPRITE_SPEEDS[imageIndex] ?? 9,
  sizePx: 96 + Math.floor(Math.random() * 26),
};
};

const getInitialPrimaryGamepad = () => {
  if (!navigator.getGamepads) return null;
  const pads = navigator.getGamepads();
  for (let i = 0; i < pads.length; i += 1) {
    if (pads[i] && pads[i].connected) {
      return pads[i];
    }
  }
  return null;
};

export default function Games() {
  const { platformId } = useParams();
  const navigate = useNavigate();
  const [games, setGames] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [selectedGame, setSelectedGame] = useState(null);
  const [boxArtUrl, setBoxArtUrl] = useState(null);
  const [loadingBoxArt, setLoadingBoxArt] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [search, setSearch] = useState('');
  const wrapperRef = useRef(null);
  const contentRef = useRef(null);
  const [platformInfo, setPlatformInfo] = useState(null);
  const [genres, setGenres] = useState([]);
  const [addableGenres, setAddableGenres] = useState([]);
  const [showAddList, setShowAddList] = useState(false);
  const [locked, setLocked] = useState(true);
  const [mobileModalOpen, setMobileModalOpen] = useState(false);
  const [viewToggle, setViewToggle] = useState(false);
  const [term, setTerm] = useState('');
  const [isFavorite, setIsFavorite] = useState(selectedGame ? selectedGame.favorite: false);
  const [scanning, setScanning] = useState(false);
  const [emulationSettings, setEmulationSettings] = useState({
    rom_path: '',
    emulator_name: '',
  });
  const [platformLaunchSettings, setPlatformLaunchSettings] = useState({
    platform_id: null,
    command_template: '',
    core: '',
    default_emulator: '',
    scrape_extensions: '',
  });
  const [savingEmulation, setSavingEmulation] = useState(false);
  const [savingPlatformLaunch, setSavingPlatformLaunch] = useState(false);
  const [launchingGame, setLaunchingGame] = useState(false);
  const [localLauncherAvailable, setLocalLauncherAvailable] = useState(false);
  const [lastLaunchFeedback, setLastLaunchFeedback] = useState(null);
  const [emulationModalOpen, setEmulationModalOpen] = useState(false);
  const [coreOptions, setCoreOptions] = useState([]);
  const [loadingCoreOptions, setLoadingCoreOptions] = useState(false);
  const [lastScrapeRootPath, setLastScrapeRootPath] = useState('');
  const [scrapeRootPath, setScrapeRootPath] = useState('/Volumes/');
  const [directoryPickerOpen, setDirectoryPickerOpen] = useState(false);
  const [directoryPickerPath, setDirectoryPickerPath] = useState('/Volumes/');
  const [directoryPickerParentPath, setDirectoryPickerParentPath] = useState(null);
  const [directoryPickerEntries, setDirectoryPickerEntries] = useState([]);
  const [loadingDirectoryPicker, setLoadingDirectoryPicker] = useState(false);
  const [romFilePickerOpen, setRomFilePickerOpen] = useState(false);
  const [romFilePickerPath, setRomFilePickerPath] = useState('/Volumes/');
  const [romFilePickerParentPath, setRomFilePickerParentPath] = useState(null);
  const [romFilePickerDirectories, setRomFilePickerDirectories] = useState([]);
  const [romFilePickerFiles, setRomFilePickerFiles] = useState([]);
  const [loadingRomFilePicker, setLoadingRomFilePicker] = useState(false);
  const [gamepadConnected, setGamepadConnected] = useState(() => Boolean(getInitialPrimaryGamepad()));
  const [gamepadName, setGamepadName] = useState(() => getInitialPrimaryGamepad()?.id || '');
  const [controllerNeedsInteraction, setControllerNeedsInteraction] = useState(false);
  const [initialDataReady, setInitialDataReady] = useState(false);
  const [boxArtCacheVersion, setBoxArtCacheVersion] = useState(0);
  const [showEntryWhiteOverlay, setShowEntryWhiteOverlay] = useState(false);
  const [entryWhiteOverlayFadeOut, setEntryWhiteOverlayFadeOut] = useState(false);
  const [loadingSprite, setLoadingSprite] = useState(() => createRandomLoadingSprite());
  const gamepadRafRef = useRef(null);
  const gamepadRepeatStateRef = useRef({});
  const gamepadConnectionStateRef = useRef({ connected: false, name: '' });
  const controllerSoundsRef = useRef({ back: null, select: null, confirm: null });
  const controllerSfxCollectionKeyRef = useRef(
    sessionStorage.getItem(ACTIVE_CONTROLLER_SFX_COLLECTION_KEY) || 'default'
  );
  const [controllerToast, setControllerToast] = useState({ open: false, message: '' });
  const controllerToastTimerRef = useRef(null);
  const previousGamepadConnectedRef = useRef(null);
  const controllerPageChangePendingRef = useRef(false);
  const controllerSelectionMovePendingRef = useRef(false);
  const lastControllerSelectionMoveAtRef = useRef(0);
  const lastControllerScrollIntoViewAtRef = useRef(0);
  const scrollAnimationFrameRef = useRef(null);
  const pendingScrollTimeoutRef = useRef(null);
  const scrollAnimationStateRef = useRef({ container: null, targetTop: 0 });
  const selectedGameIndexRef = useRef(-1);
  const isMobileRef = useRef(false);
  const emulationModalOpenRef = useRef(emulationModalOpen);
  const selectedGameRef = useRef(selectedGame);
  const launchingGameRef = useRef(launchingGame);
  const romPathRef = useRef(emulationSettings.rom_path);
  const emulationSettingsRef = useRef(emulationSettings);
  const platformLaunchSettingsRef = useRef(platformLaunchSettings);
  const platformInfoRef = useRef(platformInfo);
  const controllerNeedsInteractionRef = useRef(controllerNeedsInteraction);
  const viewToggleRef = useRef(viewToggle);
  const gamesRef = useRef(games);
  const filteredGamesRef = useRef(filteredGames);
  const selectNextGameFromControllerRef = useRef(null);
  const playSelectedGameRef = useRef(null);
  const toggleFavoriteRef = useRef(null);
  const navigateRef = useRef(navigate);
  const emulatorOptions = ['RetroArch', 'Dolphin', 'Pcsx2', 'Duckstation'];


const theme = useTheme();
const isNarrow = useMediaQuery('(max-width: 768px)'); // squished screen!
const width = useWindowWidth();
const isMobile = width < 600; // tweak this breakpoint as needed
const pageWidth = usePageWidth();
const tableWidth = pageWidth;
const toggle = () => setViewToggle(prev => !prev);
const fallbackBoxArtUrl = `${REACT_APP_URL}/assets/downloaded/default-boxart.png`;
const localLauncherInstallUrl = `${REACT_APP_API_URL}/local-launcher/install-script?site_origin=${encodeURIComponent(window.location.origin)}`;
  const checkLocalLauncher = useCallback(async () => {
    const attempt = async () => {
      await axios.get(`${LOCAL_LAUNCHER_URL}/health`, { timeout: 3000 });
    };
    try {
      await attempt();
      setLocalLauncherAvailable(true);
      return true;
    } catch (_error) {
      try {
        await attempt();
        setLocalLauncherAvailable(true);
        return true;
      } catch (retryError) {
        setLocalLauncherAvailable(false);
        return false;
      }
    }
  }, []);
  const navigateBackToPlatforms = useCallback(() => {
    sessionStorage.setItem(GAMES_TO_PLATFORMS_TRANSITION_KEY, String(Date.now()));
    if (platformId) {
      sessionStorage.setItem('platforms:lastPath', `/platforms/${platformId}`);
    }
    navigate('/');
  }, [navigate, platformId]);
  const filteredGameIndexById = useMemo(() => {
    const indexById = new Map();
    for (let i = 0; i < filteredGames.length; i += 1) {
      indexById.set(filteredGames[i].id, i);
    }
    return indexById;
  }, [filteredGames]);

  useEffect(() => {
    const hasTransitionToken = Boolean(sessionStorage.getItem(PLATFORM_TO_GAMES_TRANSITION_KEY));
    if (!hasTransitionToken) return;
    sessionStorage.removeItem(PLATFORM_TO_GAMES_TRANSITION_KEY);
    setLoadingSprite(createRandomLoadingSprite());
    setShowEntryWhiteOverlay(true);
    setEntryWhiteOverlayFadeOut(false);
  }, []);

  useEffect(() => {
    if (!showEntryWhiteOverlay || !initialDataReady) return;
    const fadeRaf = requestAnimationFrame(() => {
      setEntryWhiteOverlayFadeOut(true);
    });
    const hideTimer = setTimeout(() => {
      setShowEntryWhiteOverlay(false);
    }, 380);
    return () => {
      cancelAnimationFrame(fadeRaf);
      clearTimeout(hideTimer);
    };
  }, [initialDataReady, showEntryWhiteOverlay]);

  useEffect(() => {
    checkLocalLauncher();
  }, [checkLocalLauncher]);

  useEffect(() => {
    if (!emulationModalOpen) return;
    checkLocalLauncher();
  }, [checkLocalLauncher, emulationModalOpen]);

  useEffect(() => {
    if (!showEntryWhiteOverlay) return;
    const forceFadeTimer = setTimeout(() => {
      setEntryWhiteOverlayFadeOut(true);
    }, 1200);
    const forceHideTimer = setTimeout(() => {
      setEntryWhiteOverlayFadeOut(true);
      setShowEntryWhiteOverlay(false);
    }, 2200);
    return () => {
      clearTimeout(forceFadeTimer);
      clearTimeout(forceHideTimer);
    };
  }, [showEntryWhiteOverlay]);

  useEffect(() => {
    const initialCollectionKey = controllerSfxCollectionKeyRef.current;
    controllerSoundsRef.current = createControllerSoundSet(initialCollectionKey);
    warmControllerSounds(initialCollectionKey);
  }, []);

  useEffect(() => {
    const platformCollectionKey = resolvePlatformSfxCollectionKey(platformId);
    if (!platformCollectionKey) {
      return;
    }
    if (platformCollectionKey === controllerSfxCollectionKeyRef.current) {
      return;
    }
    controllerSfxCollectionKeyRef.current = platformCollectionKey;
    sessionStorage.setItem(ACTIVE_CONTROLLER_SFX_COLLECTION_KEY, platformCollectionKey);
    controllerSoundsRef.current = createControllerSoundSet(platformCollectionKey);
    warmControllerSounds(platformCollectionKey);
  }, [platformId]);

  const playControllerSound = useCallback((soundName) => {
    playControllerSoundFromSet(controllerSoundsRef.current, soundName);
  }, []);

  const showControllerToast = useCallback((message) => {
    if (controllerToastTimerRef.current) {
      clearTimeout(controllerToastTimerRef.current);
    }
    setControllerToast({ open: true, message });
    controllerToastTimerRef.current = setTimeout(() => {
      setControllerToast({ open: false, message: '' });
    }, 2200);
  }, []);

  useEffect(() => () => {
    if (controllerToastTimerRef.current) {
      clearTimeout(controllerToastTimerRef.current);
    }
  }, []);

  
  const handleUpdateBoxArtFromSteamGrid = async () => {
    if (!selectedGame) return;
    setLoadingBoxArt(true);
    try {
      const res = await axios.post(`${REACT_APP_API_URL}/game/${selectedGame.id}/update-boxart-steamgrid`);
      if (res.data && res.data.box_art_url) {
        const normalizedUrl = normalizeBoxArtUrl(res.data.box_art_url);
        boxArtCacheRef.current[selectedGame.id] = normalizedUrl;
        setBoxArtUrl(normalizedUrl);
        setGames(prev => prev.map(g => g.id === selectedGame.id ? { ...g, box_art_url: res.data.box_art_url } : g));
        setFilteredGames(prev => prev.map(g => g.id === selectedGame.id ? { ...g, box_art_url: res.data.box_art_url } : g));
        // Update the edit form preview dynamically
        setEditForm(prev => prev ? { ...prev, box_art_url: res.data.box_art_url } : prev);
      }
    } catch (err) {
      alert("Failed to update box art: " + (err.response?.data?.detail || err.message));
    } finally {
      setLoadingBoxArt(false);
    }
  };

const handleVisionScan = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  setScanning(true);
  const formData = new FormData();
  formData.append('file', file);
  if (platformId) {
    formData.append('platform_id', platformId);
  }

  try {
    const res = await axios.post(`${REACT_APP_API_URL}/game/identify-vision`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    if (res.data && res.data.title) {
      setEditForm(prev => ({
        ...prev,
        title: res.data.title || prev.title,
        release_year: res.data.release_year || prev.release_year,
        developer: res.data.developer || prev.developer,
        publisher: res.data.publisher || prev.publisher,
        region: res.data.region || prev.region,
        description: res.data.description || prev.description,
        box_art_url: res.data.box_art_url || prev.box_art_url, 
      }));
    } else {
      alert("Could not extract a clean title structure from the image.");
    }
  } catch (err) {
    console.error(err);
    alert('Vision scanner failed: ' + (err.response?.data?.detail || err.message));
  } finally {
    setScanning(false);
    e.target.value = null; // Clear file input
  }
};

  const sendUnlock = async (password) => {
    try {
      const response = await axios.post(`${REACT_APP_API_URL}/unlock`, { password });
      if (response.data.unlocked) {
        setLocked(false);
        sessionStorage.setItem("myToken",response.data.token);
      }
    } catch (error) {
      console.log("password check failed")
    }
  };
  
  const handleUnlock = async () => {
    const password = prompt("Enter password to unlock editing:");
    if (!password) return;
    sendUnlock(password);
  }

 const randomGame = () => {
    const index = Math.floor(Math.random() * games.length);
    setSelectedGame(games[index]);
    if (isMobile){
      setMobileModalOpen(true)
    }
  };


  useEffect(() => {
    if (selectedGame) {
      setIsFavorite(selectedGame.favorite);
    } else {
      setIsFavorite(false);
    }
  }, [selectedGame]);

  const toggleCompleted = async () => {
    if (!selectedGame) return;
    if (locked) return;
  
    try {
      const res = await axios.post(`${REACT_APP_API_URL}/game/${selectedGame.id}/toggle_completed`);
  
      setSelectedGame((prev) => ({
        ...prev,
        completed: res.data.completed,
      }));
  
      // Update games and filteredGames to keep UI consistent
      setGames((prevGames) =>
        prevGames.map((g) =>
          g.id === selectedGame.id ? { ...g, completed: res.data.completed } : g
        )
      );
      setFilteredGames((prevGames) =>
        prevGames.map((g) =>
          g.id === selectedGame.id ? { ...g, completed: res.data.completed } : g
        )
      );
    } catch (error) {
      alert('Failed to toggle completed: ' + error.message);
    }
  };
  

  const removeGenre = (genreId) => {
    if (!selectedGame) return;
    if (locked) return;
  
    axios.post(`${REACT_APP_API_URL}/games/removegenre`, {
      game_id: selectedGame.id,
      genre_id: genreId
    })
    .then(() => {
      // Update genres state
      setGenres((prev) => prev.filter((g) => g.id !== genreId));
  
      // Optional: also update selectedGame.genres if you’re using it
      updateGenres()
    })
    .catch(console.error);
  };
  
  const updateGenres = () => {
     // Fetch genres right here
     axios
     .get(`${REACT_APP_API_URL}/genres/${selectedGame.id}`)
     .then((res) => {
       setGenres(res.data.genres || []);
     })
     .catch((err) => {
       console.error("Failed to fetch genres", err);
       setGenres([]);
     });
  }

  const formatCondition = (condition) => {
    switch(condition) {
      case 'COMPLETE': return '📦 Complete';
      case 'LOOSE': return '💿 Loose';
      case 'SEALED': return '🔒 Sealed';
      case 'JUNK': return '🗑️ Junk';
      case 'MANUAL': return '📃 Missing Manual';
      default: return condition || 'N/A';
    }
  };
  
  const fetchAddableGenres = () => {
    if (!selectedGame) return;
    if (locked) return;
  
    if (showAddList) {
      // If already shown, close it
      setShowAddList(false);
      return;
    }
  
    // Otherwise fetch and open it
    axios.get(`${REACT_APP_API_URL}/genres/addlist/${selectedGame.id}`, {
      params: { game_id: selectedGame.id }
    })
    .then(res => {
      setAddableGenres(res.data.genres || []);
      setShowAddList(true);
    })
    .catch(console.error);
  };
  const handleAddGenre = async (genreId) => {
    try {
      await axios.post(`${REACT_APP_API_URL}/game/${selectedGame.id}/addgenre`, { genre_id: genreId });
  
      // Refresh addable genres list
      fetchAddableGenres();
  
      // Optionally, refresh game genres you display elsewhere
      updateGenres()
  
      setIsFavorite(selectedGame.favorite);

    } catch (err) {
      console.error("Failed to add genre", err);
    }
  };


  const [editOpen, setEditOpen] = useState(false);
    const [editForm, setEditForm] = useState(null);
    const [uploadFile, setUploadFile] = useState(null);
    const [saving, setSaving] = useState(false);
      const [igdbCandidates, setIgdbCandidates] = useState([]);
      const [igdbPlatformName, setIgdbPlatformName] = useState('');
      const [igdbDialogOpen, setIgdbDialogOpen] = useState(false);
      const [igdbLoading, setIgdbLoading] = useState(false);

    const applyIgdbGame = async (game) => {
      setEditForm((prev) => prev ? ({
        ...prev,
        title: game.title || prev.title,
        release_year: game.release_year || prev.release_year,
        developer: game.developer || prev.developer,
        publisher: game.publisher || prev.publisher,
        description: game.description || prev.description,
      }) : prev);
      setIgdbDialogOpen(false);

      try {
        const res = await axios.post(`${REACT_APP_URL}/game-info/box-art`, {
          name: game.title,
          platform_id: Number(editForm?.platform_id || platformId),
        });
        if (res.data.box_art_url) {
          setEditForm((prev) => prev ? ({
            ...prev,
            box_art_url: res.data.box_art_url,
          }) : prev);
        }
      } catch (err) {
        console.error('Failed to fetch SteamGridDB artwork for IGDB match', err);
      }
    };

    const handleIgdbAutofill = async () => {
      if (!editForm?.title || !editForm.platform_id) {
        alert('Please fill in both Title and Platform first.');
        return;
      }

      setIgdbLoading(true);
      try {
        const res = await axios.post(`${REACT_APP_URL}/game-info/search`, {
          name: editForm.title,
          platform_id: Number(editForm.platform_id),
        });
        const candidates = res.data.games || [];
        setIgdbCandidates(candidates);
        setIgdbPlatformName(res.data.platform_name || '');
        if (candidates.length > 0) {
          setIgdbDialogOpen(true);
        } else {
          alert('No game info found for this platform.');
        }
      } catch (err) {
        console.error(err);
        alert('Failed to fetch game info.');
      } finally {
        setIgdbLoading(false);
      }
    };

  const selectedGameFetchTokenRef = useRef(0);
  const selectedGameFetchTimeoutRef = useRef(null);
  const boxArtCacheRef = useRef(window.__gamesBoxArtCache || (window.__gamesBoxArtCache = {}));
  const preloadedBoxArtUrlsRef = useRef(window.__gamesPreloadedBoxArtUrls || (window.__gamesPreloadedBoxArtUrls = new Set()));
  const loadedPlatformBoxArtRef = useRef(window.__gamesLoadedPlatformBoxArt || (window.__gamesLoadedPlatformBoxArt = new Set()));
  const boxArtPreloadTaskRef = useRef(0);
  const missingArtFetchTaskRef = useRef(0);
  const genresCacheRef = useRef(
    window.__gamesGenresCache ||
    (window.__gamesGenresCache = JSON.parse(sessionStorage.getItem('games:genres-cache') || '{}'))
  );
  const emulationCacheRef = useRef(
    window.__gamesEmulationCache ||
    (window.__gamesEmulationCache = JSON.parse(sessionStorage.getItem('games:emulation-cache') || '{}'))
  );
  const detailPrefetchTaskRef = useRef(0);
  const DETAILS_FETCH_DEBOUNCE_MS = 120;

  const normalizeBoxArtUrl = useCallback((url) => {
    if (!url || typeof url !== 'string') return null;

    const cleaned = url.trim();
    if (!cleaned || cleaned === 'null' || cleaned === 'undefined') return null;
    if (cleaned.startsWith('blob:') || cleaned.startsWith('data:')) return cleaned;
    if (cleaned.startsWith('//')) return `https:${cleaned}`;
    if (cleaned.startsWith('http://') || cleaned.startsWith('https://')) return cleaned;
    if (cleaned.startsWith('/')) return `${REACT_APP_URL}${cleaned}`;
    return `${REACT_APP_URL}/${cleaned.replace(/^\/+/, '')}`;
  }, []);

  const getCachedBoxArtUrl = useCallback((game) => {
    if (!game?.id) return null;
    const normalizedFromGame = normalizeBoxArtUrl(game.box_art_url);
    if (normalizedFromGame) {
      boxArtCacheRef.current[game.id] = normalizedFromGame;
      return normalizedFromGame;
    }
    if (boxArtCacheRef.current[game.id]) {
      return boxArtCacheRef.current[game.id];
    }
    return null;
  }, [normalizeBoxArtUrl]);

  const preloadBoxArtImages = useCallback((urls) => {
    const preloadPromises = (urls || []).map((url) => {
      if (!url || preloadedBoxArtUrlsRef.current.has(url)) {
        return Promise.resolve();
      }
      return new Promise((resolve) => {
        const img = new Image();
        img.decoding = 'async';
        img.onload = () => {
          preloadedBoxArtUrlsRef.current.add(url);
          resolve();
        };
        img.onerror = () => {
          preloadedBoxArtUrlsRef.current.delete(url);
          resolve();
        };
        img.src = url;
      });
    });
    return Promise.allSettled(preloadPromises);
  }, []);

  const persistDetailCaches = useCallback(() => {
    sessionStorage.setItem('games:genres-cache', JSON.stringify(genresCacheRef.current));
    sessionStorage.setItem('games:emulation-cache', JSON.stringify(emulationCacheRef.current));
  }, []);

  const cacheGenresForGame = useCallback((gameId, nextGenres) => {
    if (!gameId) return;
    genresCacheRef.current[gameId] = Array.isArray(nextGenres) ? nextGenres : [];
    persistDetailCaches();
  }, [persistDetailCaches]);

  const cacheEmulationForGame = useCallback((gameId, payload) => {
    if (!gameId) return;
    emulationCacheRef.current[gameId] = {
      rom_path: payload?.rom_path || '',
      emulator_name: payload?.emulator_name || payload?.default_emulator || '',
      platform_id: payload?.platform_id || null,
      command_template: payload?.command_template || '',
      core: payload?.core || '',
      default_emulator: payload?.default_emulator || '',
      scrape_extensions: payload?.scrape_extensions || '',
    };
    persistDetailCaches();
  }, [persistDetailCaches]);

  const applyEmulationPayloadToState = useCallback((payload) => {
    setEmulationSettings({
      rom_path: payload?.rom_path || '',
      emulator_name: payload?.emulator_name || payload?.default_emulator || '',
    });
    setPlatformLaunchSettings({
      platform_id: payload?.platform_id || null,
      command_template: payload?.command_template || '',
      core: payload?.core || '',
      default_emulator: payload?.default_emulator || '',
      scrape_extensions: payload?.scrape_extensions || '',
    });
  }, []);

  const scheduleChunkedBoxArtPreload = useCallback((urls, options = {}) => {
    const {
      immediateCount = 96,
      chunkSize = 24,
      timeoutMs = 250,
    } = options;

    const uniqueUrls = [];
    const seen = new Set();
    (urls || []).forEach((url) => {
      if (!url || seen.has(url) || preloadedBoxArtUrlsRef.current.has(url)) return;
      seen.add(url);
      uniqueUrls.push(url);
    });

    if (!uniqueUrls.length) {
      return;
    }

    const taskId = boxArtPreloadTaskRef.current + 1;
    boxArtPreloadTaskRef.current = taskId;
    const immediateUrls = uniqueUrls.slice(0, immediateCount);
    const deferredUrls = uniqueUrls.slice(immediateCount);

    void preloadBoxArtImages(immediateUrls);

    if (!deferredUrls.length) {
      return;
    }

    let index = 0;
    const runNextChunk = () => {
      if (boxArtPreloadTaskRef.current !== taskId) return;
      const nextChunk = deferredUrls.slice(index, index + chunkSize);
      index += nextChunk.length;
      if (!nextChunk.length) return;
      void preloadBoxArtImages(nextChunk).finally(() => {
        if (index >= deferredUrls.length) return;
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(runNextChunk, { timeout: timeoutMs });
          return;
        }
        window.setTimeout(runNextChunk, 32);
      });
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(runNextChunk, { timeout: timeoutMs });
      return;
    }
    window.setTimeout(runNextChunk, 32);
  }, [preloadBoxArtImages]);

  useEffect(() => {

    sendUnlock(sessionStorage.getItem("myToken"))

    axios.get(`${REACT_APP_API_URL}/platforms/${platformId}`)
      .then(res => setPlatformInfo(res.data))
      .catch(console.error);
  }, [platformId, normalizeBoxArtUrl]);

  useEffect(() => {
    if (platformId !== '0') {
      axios
        .get(`${REACT_APP_API_URL}/platforms/${platformId}`)
        .then(res => setPlatformInfo(res.data))
        .catch(console.error);
    } else {
      setPlatformInfo(null); // for the "All" view
    }
  }, [platformId, normalizeBoxArtUrl]);
  
  
  // Helper function to get logo path
  function getConsoleLogoPath(platformName) {
    try {
      return require(`./assets/old-console-logos/${platformName.replace(/ /g, '_')}.png`);
    } catch (e) { 
      return require(`./assets/old-console-logos/default.png`);
    }
  }
  
  const toggleFavorite = useCallback(async (gameId) => {
    if (locked) return;
    try {
      const formData = new FormData();
      formData.append("id", gameId);
  
    
      const response = await fetch(`${REACT_APP_API_URL}/game/toggle_favorite`, {
        method: "POST",
        body: formData,
      });
  
      if (!response.ok) throw new Error("Failed to toggle favorite");
   
      const data = await response.json();
      const nextFavorite = Boolean(data.new_favorite);
      setIsFavorite(nextFavorite);
      setSelectedGame((prev) => (prev && prev.id === gameId ? { ...prev, favorite: nextFavorite } : prev));
      setGames((prev) => prev.map((g) => (g.id === gameId ? { ...g, favorite: nextFavorite } : g)));
      setFilteredGames((prev) => prev.map((g) => (g.id === gameId ? { ...g, favorite: nextFavorite } : g)));
      showControllerToast(nextFavorite ? '⭐ Favorited' : '☆ Unfavorited');
    } catch (error) {
      console.error("Error toggling favorite:", error);
    }
  }, [locked, showControllerToast]);

  const fetchEmulationSettings = useCallback(async (game, requestToken = null) => {
    if (!game?.id) return;

    const cachedEmulation = emulationCacheRef.current[game.id];
    if (cachedEmulation) {
      if (requestToken && requestToken !== selectedGameFetchTokenRef.current) return;
      applyEmulationPayloadToState(cachedEmulation);
      return;
    }

    try {
      const response = await axios.get(`${REACT_APP_API_URL}/game/${game.id}/emulation`);
      if (requestToken && requestToken !== selectedGameFetchTokenRef.current) return;
      cacheEmulationForGame(game.id, response.data);
      applyEmulationPayloadToState(response.data);
    } catch (error) {
      if (requestToken && requestToken !== selectedGameFetchTokenRef.current) return;
      console.error('Failed to load emulation settings', error);
      applyEmulationPayloadToState(null);
    }
  }, [applyEmulationPayloadToState, cacheEmulationForGame]);

  const saveGameEmulation = async () => {
    if (!selectedGame) return;
    setSavingEmulation(true);
    try {
      await axios.post(`${REACT_APP_API_URL}/game/${selectedGame.id}/emulation`, emulationSettings);
      alert('Emulation settings saved.');
    } catch (error) {
      alert('Failed to save emulation settings: ' + (error.response?.data?.detail || error.message));
    } finally {
      setSavingEmulation(false);
    }
  };

  const savePlatformLaunchSettings = async () => {
    if (!selectedGame) return;

    const routePlatformId = Number(platformId);
    const targetPlatformId =
      platformLaunchSettings.platform_id ||
      selectedGame.platform_id ||
      (Number.isFinite(routePlatformId) && routePlatformId > 0 ? routePlatformId : null);

    if (!targetPlatformId) {
      alert('Unable to determine platform for launch settings. Please pick a game from a specific platform list.');
      return;
    }

    setSavingPlatformLaunch(true);
    try {
      await axios.post(`${REACT_APP_API_URL}/platforms/${targetPlatformId}/emulation-config`, {
        command_template: platformLaunchSettings.command_template,
        core: platformLaunchSettings.core,
        scrape_extensions: platformLaunchSettings.scrape_extensions,
      });
      alert('Platform launch script saved.');
    } catch (error) {
      alert('Failed to save platform launch script: ' + (error.response?.data?.detail || error.message));
    } finally {
      setSavingPlatformLaunch(false);
    }
  };

  const scrapeRomPathsForPlatform = async () => {
    if (!selectedGame) return;

    const routePlatformId = Number(platformId);
    const targetPlatformId =
      platformLaunchSettings.platform_id ||
      selectedGame.platform_id ||
      (Number.isFinite(routePlatformId) && routePlatformId > 0 ? routePlatformId : null);

    if (!targetPlatformId) {
      alert('Unable to determine platform for scrape. Please pick a game from a specific platform list.');
      return;
    }

    const rootPath = (scrapeRootPath || lastScrapeRootPath || '/Volumes/').trim();
    if (!rootPath) return;

    setLastScrapeRootPath(rootPath);

    try {
      const preview = await axios.post(`${REACT_APP_API_URL}/platforms/${targetPlatformId}/emulation/scrape`, {
        root_path: rootPath,
        apply: false,
        recursive: true,
        force_overwrite: false,
        min_match_confidence: 0.55,
        min_apply_confidence: 0.75,
      });

      const previewData = preview.data;
      const confirmApply = window.confirm(
        `Preview complete for ${previewData.platform_name}\n` +
        `Candidates found: ${previewData.rom_candidates_found}\n` +
        `Matches found: ${previewData.matched_count}\n` +
        `Unmatched: ${previewData.unmatched_count}\n\n` +
        'Apply these matches to games that do not already have a ROM path?'
      );

      if (!confirmApply) return;

      const applied = await axios.post(`${REACT_APP_API_URL}/platforms/${targetPlatformId}/emulation/scrape`, {
        root_path: rootPath,
        apply: true,
        recursive: true,
        force_overwrite: false,
        min_match_confidence: 0.55,
        min_apply_confidence: 0.75,
      });

      const appliedData = applied.data;
      alert(
        `ROM scrape completed.\n` +
        `Applied: ${appliedData.applied_count}\n` +
        `Matched: ${appliedData.matched_count}\n` +
        `Unmatched: ${appliedData.unmatched_count}`
      );

      if (selectedGame) {
        fetchEmulationSettings(selectedGame);
      }
    } catch (error) {
      alert('Failed to scrape ROM paths: ' + (error.response?.data?.detail || error.message));
    }
  };

  const prefetchGameDetails = useCallback((game) => {
    if (!game?.id) return;
    if (!genresCacheRef.current[game.id]) {
      axios
        .get(`${REACT_APP_API_URL}/genres/${game.id}`)
        .then((res) => {
          cacheGenresForGame(game.id, res.data.genres || []);
        })
        .catch(() => {});
    }

    if (!emulationCacheRef.current[game.id]) {
      axios
        .get(`${REACT_APP_API_URL}/game/${game.id}/emulation`)
        .then((res) => {
          cacheEmulationForGame(game.id, res.data);
        })
        .catch(() => {});
    }
  }, [cacheEmulationForGame, cacheGenresForGame]);

  const loadDirectoryEntries = async (pathToLoad) => {
    setLoadingDirectoryPicker(true);
    try {
      const response = await axios.get(`${REACT_APP_API_URL}/filesystem/directories`, {
        params: { path: pathToLoad },
      });
      setDirectoryPickerPath(response.data.path);
      setDirectoryPickerParentPath(response.data.parent_path || null);
      setDirectoryPickerEntries(response.data.directories || []);
    } catch (error) {
      alert('Failed to load directories: ' + (error.response?.data?.detail || error.message));
    } finally {
      setLoadingDirectoryPicker(false);
    }
  };

  const openDirectoryPicker = async () => {
    const initialPath = (scrapeRootPath || lastScrapeRootPath || '/Volumes/').trim();
    setDirectoryPickerOpen(true);
    await loadDirectoryEntries(initialPath);
  };

  const getInitialRomPickerPath = () => {
    const currentRomPath = (emulationSettings.rom_path || '').trim();
    if (currentRomPath.includes('/')) {
      const lastSlash = currentRomPath.lastIndexOf('/');
      if (lastSlash > 0) {
        return currentRomPath.substring(0, lastSlash);
      }
    }
    return (scrapeRootPath || lastScrapeRootPath || '/Volumes/').trim();
  };

  const loadRomFileEntries = async (pathToLoad) => {
    setLoadingRomFilePicker(true);
    try {
      const response = await axios.get(`${REACT_APP_API_URL}/filesystem/entries`, {
        params: { path: pathToLoad },
      });
      setRomFilePickerPath(response.data.path);
      setRomFilePickerParentPath(response.data.parent_path || null);
      setRomFilePickerDirectories(response.data.directories || []);
      setRomFilePickerFiles(response.data.files || []);
    } catch (error) {
      alert('Failed to load files: ' + (error.response?.data?.detail || error.message));
    } finally {
      setLoadingRomFilePicker(false);
    }
  };

  const openRomFilePicker = async () => {
    setRomFilePickerOpen(true);
    await loadRomFileEntries(getInitialRomPickerPath());
  };

  const playSelectedGame = async () => {
    const currentSelectedGame = selectedGameRef.current;
    if (!currentSelectedGame) return;
    const currentEmulationSettings = emulationSettingsRef.current;
    const currentPlatformLaunchSettings = platformLaunchSettingsRef.current;
    const currentPlatformInfo = platformInfoRef.current;
    setLaunchingGame(true);
    setLastLaunchFeedback(null);
    try {
      const launchPayload = {
        game_id: currentSelectedGame.id,
        title: currentSelectedGame.title,
        platform_id: currentSelectedGame.platform_id || Number(platformId),
        platform_name: currentSelectedGame.platform_name || currentPlatformInfo?.name || '',
        rom_path: currentEmulationSettings.rom_path,
        emulator_name: currentEmulationSettings.emulator_name || currentPlatformLaunchSettings.default_emulator || 'RetroArch',
        command_template: currentPlatformLaunchSettings.command_template,
        core: currentPlatformLaunchSettings.core,
        return_to_browser_on_close: true
      };

      const response = await axios.post(`${LOCAL_LAUNCHER_URL}/launch`, launchPayload, {
        timeout: 5000,
      });
      if (response.data?.return_focus_armed) {
        sessionStorage.setItem(RETURN_FROM_LAUNCH_FOCUS_KEY, '1');
      } else {
        sessionStorage.removeItem(RETURN_FROM_LAUNCH_FOCUS_KEY);
      }
      setLastLaunchFeedback({
        status: 'success',
        detail: 'Launch request sent to local launcher.',
        launch_command: response.data.launch_command || '',
        suggested_command_template: null,
      });
      setLocalLauncherAvailable(true);
    } catch (error) {
      sessionStorage.removeItem(RETURN_FROM_LAUNCH_FOCUS_KEY);
      const isLauncherConnectionIssue = !error.response;
      setLocalLauncherAvailable(!isLauncherConnectionIssue);

      if (window.location.hostname === 'localhost') {
        try {
          const fallbackResponse = await axios.post(`${REACT_APP_API_URL}/game/${currentSelectedGame.id}/play`);
          setLastLaunchFeedback({
            status: 'success',
            detail: 'Launch request sent to backend launcher.',
            launch_command: fallbackResponse.data.launch_command || '',
            suggested_command_template: null,
          });
          return;
        } catch (_fallbackError) {
          // Continue to the structured failure handling below.
        }
      }

      const failureData = error.response?.data || {};
      const detail = isLauncherConnectionIssue
        ? 'Local launcher is not running. Install it once, then return here and click Play again.'
        : (failureData.detail || error.message);
      setLastLaunchFeedback({
        status: 'error',
        detail,
        launch_command: failureData.launch_command || '',
        suggested_command_template: failureData.suggested_command_template || null,
      });
      setEmulationModalOpen(true);
      alert(`Failed to launch game: ${detail}`);
    } finally {
      setLaunchingGame(false);
    }
  };

  const selectNextGameFromController = (direction) => {
    if (!filteredGames.length) return;
    controllerSelectionMovePendingRef.current = true;
    lastControllerSelectionMoveAtRef.current = performance.now();
    playControllerSound('select');
    const currentIndex = selectedGameIndexRef.current;
    const startIndex = currentIndex >= 0 ? currentIndex : 0;
    const gameCount = filteredGames.length;
    const nextIndex = ((startIndex + direction) % gameCount + gameCount) % gameCount;
    const nextGame = filteredGames[nextIndex];
    if (!nextGame) return;
    if (nextGame.id === selectedGameRef.current?.id) return;
    let pageChanged = false;
    if (viewToggle) {
      const targetPage = Math.floor(nextIndex / pageSize);
      if (targetPage !== page) {
        pageChanged = true;
        setPage(targetPage);
      }
    }
    controllerPageChangePendingRef.current = pageChanged;
    selectedGameIndexRef.current = nextIndex;
    selectedGameRef.current = nextGame;
    setSelectedGame(nextGame);
  };

  const getGridStepSize = () => {
    const cards = Array.from(document.querySelectorAll('[data-game-id]'));
    if (!cards.length) return 4;

    // Use layout position instead of transformed position so animated selected cards
    // do not break row/column detection.
    const firstTop = cards[0].offsetTop;
    let columns = 0;
    for (const card of cards) {
      const top = card.offsetTop;
      if (Math.abs(top - firstTop) < 2) {
        columns += 1;
      } else {
        break;
      }
    }

    return Math.max(1, columns || 4);
  };

  const scrollGameIntoView = useCallback((gameId, delayMs = 0) => {
    const getScrollableContainer = (element) => {
      const cachedContainer = scrollAnimationStateRef.current.container;
      if (cachedContainer && cachedContainer.contains(element)) {
        return cachedContainer;
      }

      let current = element?.parentElement;
      while (current) {
        const style = window.getComputedStyle(current);
        const overflowY = style.overflowY;
        if ((overflowY === 'auto' || overflowY === 'scroll') && current.scrollHeight > current.clientHeight) {
          return current;
        }
        current = current.parentElement;
      }
      return document.scrollingElement || document.documentElement;
    };

    const getTargetTopWithinContainer = (element, container) => {
      const elementRect = element.getBoundingClientRect();
      const containerRect = container.getBoundingClientRect();
      return (
        container.scrollTop +
        (elementRect.top - containerRect.top) -
        ((container.clientHeight - elementRect.height) / 2)
      );
    };

    const ensureScrollAnimation = () => {
      if (scrollAnimationFrameRef.current) {
        return;
      }

      const step = () => {
        const { container, targetTop } = scrollAnimationStateRef.current;
        if (!container) {
          scrollAnimationFrameRef.current = null;
          return;
        }

        const currentTop = container.scrollTop;
        const distance = targetTop - currentTop;

        if (Math.abs(distance) < 2) {
          container.scrollTop = targetTop;
          scrollAnimationFrameRef.current = null;
          return;
        }

        const distanceMagnitude = Math.abs(distance);
        const speedMultiplier =
          distanceMagnitude > 2200 ? 0.55 :
          distanceMagnitude > 1400 ? 0.46 :
          distanceMagnitude > 700 ? 0.38 :
          0.32;
        const maxStep =
          distanceMagnitude > 2200 ? 320 :
          distanceMagnitude > 1400 ? 240 :
          distanceMagnitude > 700 ? 170 :
          110;
        const nextStep = Math.max(-maxStep, Math.min(maxStep, distance * speedMultiplier));
        container.scrollTop = currentTop + (Math.abs(nextStep) < 2 ? Math.sign(distance) * 2 : nextStep);
        scrollAnimationFrameRef.current = requestAnimationFrame(step);
      };

      scrollAnimationFrameRef.current = requestAnimationFrame(step);
    };

    const scrollToTarget = () => {
      lastControllerScrollIntoViewAtRef.current = performance.now();
      const rowElement = document.querySelector(`[data-id="${gameId}"]`);
      const gridCardElement = document.querySelector(`[data-game-id="${gameId}"]`);
      const targetElement = rowElement || gridCardElement;
      if (!targetElement) return;

      const container = getScrollableContainer(targetElement);
      const targetTop = getTargetTopWithinContainer(targetElement, container);

      scrollAnimationStateRef.current = {
        container,
        targetTop: Math.max(0, targetTop),
      };

      const useSnappyScroll = filteredGames.length > LARGE_LIST_SNAPPY_THRESHOLD;
      if (useSnappyScroll) {
        container.scrollTop = scrollAnimationStateRef.current.targetTop;
        return;
      }

      ensureScrollAnimation();
    };

    if (delayMs > 0) {
      if (pendingScrollTimeoutRef.current) {
        clearTimeout(pendingScrollTimeoutRef.current);
      }
      pendingScrollTimeoutRef.current = setTimeout(scrollToTarget, delayMs);
      return;
    }
    requestAnimationFrame(scrollToTarget);
  }, [filteredGames.length]);

  useEffect(() => { isMobileRef.current = isMobile; }, [isMobile]);
  useEffect(() => { emulationModalOpenRef.current = emulationModalOpen; }, [emulationModalOpen]);
  useEffect(() => { selectedGameRef.current = selectedGame; }, [selectedGame]);
  useEffect(() => { emulationSettingsRef.current = emulationSettings; }, [emulationSettings]);
  useEffect(() => { platformLaunchSettingsRef.current = platformLaunchSettings; }, [platformLaunchSettings]);
  useEffect(() => { platformInfoRef.current = platformInfo; }, [platformInfo]);
  useEffect(() => {
    setLastLaunchFeedback(null);
  }, [selectedGame?.id]);
  useEffect(() => () => {
    if (scrollAnimationFrameRef.current) {
      cancelAnimationFrame(scrollAnimationFrameRef.current);
    }
    if (pendingScrollTimeoutRef.current) {
      clearTimeout(pendingScrollTimeoutRef.current);
    }
  }, []);
  useEffect(() => {
    if (!selectedGame) {
      selectedGameIndexRef.current = -1;
      return;
    }
    selectedGameIndexRef.current = filteredGameIndexById.get(selectedGame.id) ?? -1;
  }, [selectedGame, filteredGameIndexById]);
  useEffect(() => { launchingGameRef.current = launchingGame; }, [launchingGame]);
  useEffect(() => { romPathRef.current = emulationSettings.rom_path; }, [emulationSettings.rom_path]);
  useEffect(() => { controllerNeedsInteractionRef.current = controllerNeedsInteraction; }, [controllerNeedsInteraction]);
  useEffect(() => { viewToggleRef.current = viewToggle; }, [viewToggle]);
  useEffect(() => { gamesRef.current = games; }, [games]);
  useEffect(() => { filteredGamesRef.current = filteredGames; }, [filteredGames]);
  selectNextGameFromControllerRef.current = selectNextGameFromController;
  playSelectedGameRef.current = playSelectedGame;
  toggleFavoriteRef.current = toggleFavorite;
  navigateRef.current = navigateBackToPlatforms;

  const renderEmulationControls = () => {
    if (!selectedGame || isMobile) return null;
    const selectedEmulator = emulationSettings.emulator_name || platformLaunchSettings.default_emulator;
    const isRetroArchSelected = selectedEmulator === 'RetroArch';
    const isPlayDisabled = launchingGame || !emulationSettings.rom_path;
    const coreOptionValues = platformLaunchSettings.core && !coreOptions.includes(platformLaunchSettings.core)
      ? [platformLaunchSettings.core, ...coreOptions]
      : coreOptions;

    return (
      <Box sx={{ width: '100%', mt: 1, mb: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1, mb: 1 }}>
          <button
            className={`snazzy-button${isPlayDisabled ? '' : ' play-button-active'}`}
            onClick={playSelectedGame}
            disabled={isPlayDisabled}
            style={{
              minWidth: '140px',
              background: isPlayDisabled ? '#bdbdbd' : undefined,
              boxShadow: isPlayDisabled ? 'none' : undefined,
              cursor: isPlayDisabled ? 'not-allowed' : 'pointer',
              opacity: isPlayDisabled ? 0.7 : 1,
            }}
          >
            {launchingGame ? '🚀 Launching...' : '🎮 Play'}
          </button>

          <IconButton
            onClick={() => setEmulationModalOpen(true)}
            aria-label="Emulator settings"
            sx={{
              backgroundColor: 'rgba(255,255,255,0.7)',
              border: '1px solid rgba(0,0,0,0.12)',
              '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
            }}
          >
            <SettingsIcon />
          </IconButton>
        </Box>

        <Dialog
          open={emulationModalOpen}
          onClose={() => setEmulationModalOpen(false)}
          fullWidth
          maxWidth="sm"
        >
         <DialogTitle>Emulator Settings</DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 0.5, mb: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                <Typography variant="body2" color={localLauncherAvailable ? 'success.main' : 'text.secondary'} sx={{ fontWeight: 700 }}>
                  {localLauncherAvailable ? 'Local launcher connected.' : 'Local launcher not detected yet.'}
                </Typography>
                
                {localLauncherAvailable && (
                  <Button
                    component="a"
                    href={localLauncherInstallUrl}
                    rel="noreferrer"
                    download="install_gamecollection_launcher.zip"
                    size="small"
                    variant="outlined"
                  >
                    Update Launcher Script
                  </Button>
                )}
              </Box>

              {!localLauncherAvailable && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    Install the local launcher once, then this site can start emulators on this Mac.
                  </Typography>
                  <Button
                    component="a"
                    href={localLauncherInstallUrl}
                    rel="noreferrer"
                    download="install_gamecollection_launcher.zip"
                    size="small"
                    variant="outlined"
                    sx={{ mt: 1 }}
                  >
                    Download Local Launcher Installer
                  </Button>
                </Box>
              )}
              {lastLaunchFeedback?.status !== 'error' && lastLaunchFeedback?.detail && (
                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    color: 'text.secondary',
                  }}
                >
                  {lastLaunchFeedback.detail}
                </Typography>
              )}
            </Box>
            <TextField
              label="ROM Path"
              fullWidth
              size="small"
              margin="dense"
              value={emulationSettings.rom_path}
              onChange={(e) => setEmulationSettings((prev) => ({ ...prev, rom_path: e.target.value }))}
              InputProps={{ readOnly: locked }}
            />
            {!locked && (
              <button
                className="snazzy-button"
                onClick={openRomFilePicker}
                style={{ marginTop: '6px' }}
              >
                🗂️ Pick ROM File
              </button>
            )}
            <FormControl fullWidth size="small" margin="dense">
              <InputLabel id="emulator-label">Emulator</InputLabel>
              <Select
                labelId="emulator-label"
                label="Emulator"
                value={emulationSettings.emulator_name || ''}
                onChange={(e) => setEmulationSettings((prev) => ({ ...prev, emulator_name: e.target.value }))}
                disabled={locked}
              >
                <MenuItem value="">
                  Use Default ({platformLaunchSettings.default_emulator || 'RetroArch'})
                </MenuItem>
                {emulatorOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {!locked && (
              <button
                className="snazzy-button"
                onClick={saveGameEmulation}
                disabled={savingEmulation}
                style={{ marginTop: '6px' }}
              >
                {savingEmulation ? 'Saving...' : 'Save ROM Settings'}
              </button>
            )}

            <TextField
              label="Platform Launch Script"
              fullWidth
              size="small"
              multiline
              minRows={2}
              margin="dense"
              value={platformLaunchSettings.command_template}
              onChange={(e) => setPlatformLaunchSettings((prev) => ({ ...prev, command_template: e.target.value }))}
              helperText="Tokens: {emulator_name}, {rom_path}, {core}, {core_arg}"
              InputProps={{ readOnly: locked }}
            />
            {lastLaunchFeedback?.status === 'error' && (
              <Box sx={{ mt: 1, mb: 1 }}>
                <Typography variant="body2" color="error.main" sx={{ fontWeight: 700 }}>
                  Last launch failed
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {lastLaunchFeedback.detail}
                </Typography>
                {lastLaunchFeedback.launch_command && (
                  <TextField
                    label="Last Rendered Launch Command"
                    fullWidth
                    size="small"
                    margin="dense"
                    value={lastLaunchFeedback.launch_command}
                    InputProps={{ readOnly: true }}
                  />
                )}
                {lastLaunchFeedback.suggested_command_template && !locked && (
                  <button
                    className="snazzy-button"
                    onClick={() => setPlatformLaunchSettings((prev) => ({
                      ...prev,
                      command_template: lastLaunchFeedback.suggested_command_template,
                    }))}
                    style={{ marginTop: '6px' }}
                  >
                    Use Suggested Script
                  </button>
                )}
              </Box>
            )}
            <FormControl fullWidth size="small" margin="dense">
              <InputLabel id="core-label">Platform Core (optional)</InputLabel>
              <Select
                labelId="core-label"
                label="Platform Core (optional)"
                value={platformLaunchSettings.core || ''}
                onChange={(e) => setPlatformLaunchSettings((prev) => ({ ...prev, core: e.target.value }))}
                disabled={locked || !isRetroArchSelected || loadingCoreOptions}
              >
                <MenuItem value="">None</MenuItem>
                {coreOptionValues.map((coreName) => (
                  <MenuItem key={coreName} value={coreName}>
                    {coreName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" color="text.secondary">
              {isRetroArchSelected
                ? (loadingCoreOptions ? 'Loading RetroArch cores...' : 'Cores loaded from your RetroArch cores folder.')
                : 'Core is only used when emulator is RetroArch.'}
            </Typography>
            <TextField
              label="Scraper File Types (comma-separated)"
              fullWidth
              size="small"
              margin="dense"
              value={platformLaunchSettings.scrape_extensions || ''}
              onChange={(e) => setPlatformLaunchSettings((prev) => ({ ...prev, scrape_extensions: e.target.value }))}
              helperText="Example: .bin, .md, .smd, .gen"
              InputProps={{ readOnly: locked }}
            />

            {!locked && (
              <button
                className="snazzy-button"
                onClick={savePlatformLaunchSettings}
                disabled={savingPlatformLaunch}
                style={{ marginTop: '6px' }}
              >
                {savingPlatformLaunch ? 'Saving...' : 'Save Platform Script'}
              </button>
            )}

            {!locked && (
              <button
                className="snazzy-button"
                onClick={scrapeRomPathsForPlatform}
                style={{ marginTop: '6px', marginLeft: '8px' }}
              >
                🧲 Scrape ROM Paths
              </button>
            )}

            {!locked && (
              <>
                <TextField
                  label="Scrape Root Path"
                  fullWidth
                  size="small"
                  margin="dense"
                  value={scrapeRootPath}
                  onChange={(e) => setScrapeRootPath(e.target.value)}
                />
                <button
                  className="snazzy-button"
                  onClick={openDirectoryPicker}
                  style={{ marginTop: '6px' }}
                >
                  📁 Pick Folder
                </button>
              </>
            )}
          </DialogContent>
        </Dialog>

        <Dialog
          open={directoryPickerOpen}
          onClose={() => setDirectoryPickerOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Select ROM Folder</DialogTitle>
          <DialogContent>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Current: {directoryPickerPath}
            </Typography>
            {loadingDirectoryPicker ? (
              <Typography variant="body2">Loading folders...</Typography>
            ) : (
              <List dense>
                {directoryPickerParentPath && (
                  <ListItemButton onClick={() => loadDirectoryEntries(directoryPickerParentPath)}>
                    <ListItemText primary=".. (Parent Folder)" />
                  </ListItemButton>
                )}
                {directoryPickerEntries.map((entry) => (
                  <ListItemButton key={entry.path} onClick={() => loadDirectoryEntries(entry.path)}>
                    <ListItemText primary={entry.name} />
                  </ListItemButton>
                ))}
              </List>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDirectoryPickerOpen(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => {
                setScrapeRootPath(directoryPickerPath);
                setLastScrapeRootPath(directoryPickerPath);
                setDirectoryPickerOpen(false);
              }}
            >
              Use This Folder
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={romFilePickerOpen}
          onClose={() => setRomFilePickerOpen(false)}
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle>Select ROM File</DialogTitle>
          <DialogContent>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Current: {romFilePickerPath}
            </Typography>
            {loadingRomFilePicker ? (
              <Typography variant="body2">Loading files...</Typography>
            ) : (
              <List dense>
                {romFilePickerParentPath && (
                  <ListItemButton onClick={() => loadRomFileEntries(romFilePickerParentPath)}>
                    <ListItemText primary=".. (Parent Folder)" />
                  </ListItemButton>
                )}
                {romFilePickerDirectories.map((entry) => (
                  <ListItemButton key={entry.path} onClick={() => loadRomFileEntries(entry.path)}>
                    <ListItemText primary={`📁 ${entry.name}`} />
                  </ListItemButton>
                ))}
                {romFilePickerFiles.map((entry) => (
                  <ListItemButton
                    key={entry.path}
                    onClick={() => {
                      setEmulationSettings((prev) => ({ ...prev, rom_path: entry.path }));
                      setRomFilePickerOpen(false);
                    }}
                  >
                    <ListItemText primary={`🎮 ${entry.name}`} />
                  </ListItemButton>
                ))}
              </List>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setRomFilePickerOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  };
  

  // Load games on platform change
  useEffect(() => {
    let cancelled = false;
    setInitialDataReady(false);
    setSelectedGame(null);
    setBoxArtUrl(null);

    const loadGames = async () => {
      try {
        const gamesResponse = await axios.get(`${REACT_APP_API_URL}/platforms/${platformId}/games`);
        if (cancelled) return;
        const prefillUrls = [];
        (gamesResponse.data || []).forEach((game) => {
          const normalizedUrl = normalizeBoxArtUrl(game.box_art_url);
          if (game?.id && normalizedUrl) {
            boxArtCacheRef.current[game.id] = normalizedUrl;
            prefillUrls.push(normalizedUrl);
            return;
          }
          if (game?.id && boxArtCacheRef.current[game.id]) {
            prefillUrls.push(boxArtCacheRef.current[game.id]);
          }
        });
        setGames(gamesResponse.data);
        setFilteredGames(gamesResponse.data);
        await preloadBoxArtImages(prefillUrls.slice(0, 96));
        scheduleChunkedBoxArtPreload(prefillUrls.slice(96));
      } catch (error) {
        if (!cancelled) {
          console.error(error);
        }
      }
    };

    const preloadBoxArtCache = async () => {
      if (loadedPlatformBoxArtRef.current.has(platformId)) {
        return;
      }
      try {
        const boxArtsResponse = await axios.post(`${REACT_APP_API_URL}/platform/boxarts/${platformId}`);
        if (cancelled) return;

        const nextCache = {};
        (boxArtsResponse.data || []).forEach((entry) => {
          const normalizedUrl = normalizeBoxArtUrl(entry.url);
          if (entry?.id && normalizedUrl) {
            nextCache[entry.id] = normalizedUrl;
          }
        });

        Object.assign(boxArtCacheRef.current, nextCache);
        window.__gamesBoxArtCache = boxArtCacheRef.current;
        loadedPlatformBoxArtRef.current.add(platformId);
        setBoxArtCacheVersion((v) => v + 1);
        const urls = Object.values(nextCache);
        await preloadBoxArtImages(urls.slice(0, 96));
        scheduleChunkedBoxArtPreload(urls.slice(96));
      } catch (error) {
        if (!cancelled) {
          console.error(error);
        }
      }
    };

    const loadInitialData = async () => {
      await Promise.allSettled([loadGames(), preloadBoxArtCache()]);
      if (!cancelled) {
        setInitialDataReady(true);
      }
    };

    loadInitialData();

    return () => {
      cancelled = true;
      boxArtPreloadTaskRef.current += 1;
    };
  }, [platformId, normalizeBoxArtUrl, preloadBoxArtImages, scheduleChunkedBoxArtPreload]);

  // Sort baseline first, then apply search filters
  useEffect(() => {
    const lower = search.toLowerCase();
    
    // 1. Create a copy of the games array to avoid mutating state directly
    let data = [...games];

    // 2. Apply the primary Sort
    if (platformId === '99') {
      // Sort by Grade (Highest to Lowest)
      // Uses parseFloat and || 0 to handle nulls or strings safely
      data.sort((a, b) => (parseFloat(b.grade) || 0) - (parseFloat(a.grade) || 0));
    } else {
      // Default: Sort by Title Alphabetically
      data.sort((a, b) => (a.title || "").localeCompare(b.title || ""));
    }

    // 3. Filter the already-sorted list based on the search term
    const finalFilteredList = data.filter((g) =>
      g.title.toLowerCase().includes(lower) ||
      (g.developer && g.developer.toLowerCase().includes(lower)) ||
      (g.publisher && g.publisher.toLowerCase().includes(lower)) ||
      (g.region && g.region.toLowerCase().includes(lower))
    );

    setFilteredGames(finalFilteredList);
  }, [search, games, platformId]); // Ensure platformId is a dependency
  
  // Fetch box art when selectedGame changes
  useEffect(() => {
    if (!selectedGame) {
      selectedGameFetchTokenRef.current += 1;
      if (selectedGameFetchTimeoutRef.current) {
        clearTimeout(selectedGameFetchTimeoutRef.current);
      }
      setEmulationSettings({ rom_path: '', emulator_name: '' });
      setPlatformLaunchSettings({ platform_id: null, command_template: '', core: '', default_emulator: '', scrape_extensions: '' });
      setEmulationModalOpen(false);
      return;
    }

    const requestToken = selectedGameFetchTokenRef.current + 1;
    selectedGameFetchTokenRef.current = requestToken;
    const cachedBoxArtUrl = getCachedBoxArtUrl(selectedGame);
    const cachedGenres = genresCacheRef.current[selectedGame.id];
    const cachedEmulation = emulationCacheRef.current[selectedGame.id];
    const recentControllerMoveMs = performance.now() - lastControllerSelectionMoveAtRef.current;
    const isRapidControllerNavigation = recentControllerMoveMs >= 0 && recentControllerMoveMs < 220;

    if (cachedBoxArtUrl && !isRapidControllerNavigation) {
      setBoxArtUrl(cachedBoxArtUrl);
    }
    if (cachedGenres) {
      setGenres(cachedGenres);
    }
    if (cachedEmulation) {
      applyEmulationPayloadToState(cachedEmulation);
    }

    if (selectedGameFetchTimeoutRef.current) {
      clearTimeout(selectedGameFetchTimeoutRef.current);
    }

    selectedGameFetchTimeoutRef.current = setTimeout(() => {
      if (cachedBoxArtUrl) {
        setBoxArtUrl(cachedBoxArtUrl);
      }
      if (!cachedBoxArtUrl) {
        setLoadingBoxArt(true);
        axios
          .get(`${REACT_APP_API_URL}/game/boxart`, {
            params: { game_id: selectedGame.id, game_name: selectedGame.title },
          })
          .then((res) => {
            if (requestToken !== selectedGameFetchTokenRef.current) return;
            const resolvedUrl = normalizeBoxArtUrl(res.data.box_art_url);
            if (resolvedUrl) {
              boxArtCacheRef.current[selectedGame.id] = resolvedUrl;
              preloadBoxArtImages([resolvedUrl]);
            }
            setBoxArtUrl(resolvedUrl);
          })
          .catch(() => {
            if (requestToken !== selectedGameFetchTokenRef.current) return;
            setBoxArtUrl(null);
          })
          .finally(() => {
            if (requestToken === selectedGameFetchTokenRef.current) {
              setLoadingBoxArt(false);
            }
          });
      }

      axios
        .get(`${REACT_APP_API_URL}/genres/${selectedGame.id}`)
        .then((res) => {
          if (requestToken !== selectedGameFetchTokenRef.current) return;
          const nextGenres = res.data.genres || [];
          cacheGenresForGame(selectedGame.id, nextGenres);
          setGenres(nextGenres);
        })
        .catch((err) => {
          if (requestToken !== selectedGameFetchTokenRef.current) return;
          console.error("Failed to fetch genres", err);
          setGenres([]);
        });

      fetchEmulationSettings(selectedGame, requestToken);
    }, DETAILS_FETCH_DEBOUNCE_MS);

    return () => {
      if (selectedGameFetchTimeoutRef.current) {
        clearTimeout(selectedGameFetchTimeoutRef.current);
      }
    };
  }, [selectedGame, getCachedBoxArtUrl, normalizeBoxArtUrl, preloadBoxArtImages, applyEmulationPayloadToState, cacheGenresForGame, fetchEmulationSettings]);

  useEffect(() => {
    if (!initialDataReady || !filteredGames.length) return;

    const candidates = filteredGames
      .filter((game) => game?.id && game.id !== selectedGame?.id)
      .slice(0, 6);

    if (!candidates.length) return;

    const taskId = detailPrefetchTaskRef.current + 1;
    detailPrefetchTaskRef.current = taskId;

    const runPrefetch = () => {
      if (detailPrefetchTaskRef.current !== taskId) return;
      candidates.forEach((game, index) => {
        window.setTimeout(() => {
          if (detailPrefetchTaskRef.current !== taskId) return;
          prefetchGameDetails(game);
        }, index * 75);
      });
    };

    if (typeof window.requestIdleCallback === 'function') {
      const idleId = window.requestIdleCallback(runPrefetch, { timeout: 1000 });
      return () => {
        detailPrefetchTaskRef.current += 1;
        window.cancelIdleCallback(idleId);
      };
    }

    const timerId = window.setTimeout(runPrefetch, 200);
    return () => {
      detailPrefetchTaskRef.current += 1;
      clearTimeout(timerId);
    };
  }, [initialDataReady, filteredGames, selectedGame?.id, prefetchGameDetails]);

  useEffect(() => {
    if (!emulationModalOpen) return;

    const loadCoreOptions = async () => {
      setLoadingCoreOptions(true);
      try {
        const response = await axios.get(`${REACT_APP_API_URL}/emulation/cores`);
        setCoreOptions(response.data.cores || []);
      } catch (error) {
        console.error('Failed to load RetroArch cores', error);
        setCoreOptions([]);
      } finally {
        setLoadingCoreOptions(false);
      }
    };

    loadCoreOptions();
  }, [emulationModalOpen]);

  useEffect(() => {
    const getPrimaryGamepad = () => {
      if (!navigator.getGamepads) return null;
      const pads = navigator.getGamepads();
      for (let i = 0; i < pads.length; i += 1) {
        if (pads[i] && pads[i].connected) {
          return pads[i];
        }
      }
      return null;
    };

    const updateGamepadConnection = (pad) => {
      const nextConnected = Boolean(pad);
      const nextName = pad?.id || '';
      if (gamepadConnectionStateRef.current.connected !== nextConnected) {
        gamepadConnectionStateRef.current.connected = nextConnected;
        setGamepadConnected(nextConnected);
      }
      if (gamepadConnectionStateRef.current.name !== nextName) {
        gamepadConnectionStateRef.current.name = nextName;
        setGamepadName(nextName);
      }
    };

    const runControllerLoop = () => {
      const pad = getPrimaryGamepad();
      updateGamepadConnection(pad);

      if (pad && !isMobileRef.current) {
        const now = performance.now();
        const isPressed = (buttonIndex) => Boolean(pad.buttons?.[buttonIndex]?.pressed);
        if (window.__controllerBackHeld === undefined) {
          window.__controllerBackHeld = false;
        }
        const backPressed = isPressed(1);
        if (!backPressed) {
          window.__controllerBackHeld = false;
        }
        const backJustPressed = backPressed && !window.__controllerBackHeld;
        if (backJustPressed) {
          window.__controllerBackHeld = true;
        }
        const hasAnyInput = () =>
          Boolean(pad.buttons?.some((button) => button?.pressed)) ||
          Math.abs(pad.axes?.[0] || 0) > 0.35 ||
          Math.abs(pad.axes?.[1] || 0) > 0.35;
        const shouldHandlePress = (key, pressed, repeat = false) => {
          const useSnappyLargeListMode =
            (filteredGamesRef.current?.length || 0) > LARGE_LIST_SNAPPY_THRESHOLD;
          const repeatInitialDelay = useSnappyLargeListMode
            ? LARGE_LIST_REPEAT_INITIAL_DELAY_MS
            : CONTROLLER_REPEAT_INITIAL_DELAY_MS;
          const repeatInterval = useSnappyLargeListMode
            ? LARGE_LIST_REPEAT_INTERVAL_MS
            : CONTROLLER_REPEAT_INTERVAL_MS;
          const existingState = gamepadRepeatStateRef.current[key];
          if (!pressed) {
            delete gamepadRepeatStateRef.current[key];
            return false;
          }
          if (!existingState) {
            gamepadRepeatStateRef.current[key] = {
              heldSince: now,
              lastTriggeredAt: now,
            };
            return true;
          }
          if (!repeat) return false;
          const heldFor = now - existingState.heldSince;
          const sinceLastTrigger = now - existingState.lastTriggeredAt;
          if (
            heldFor >= repeatInitialDelay &&
            sinceLastTrigger >= repeatInterval
          ) {
            existingState.lastTriggeredAt = now;
            return true;
          }
          return false;
        };
        const shouldHandleButton = (buttonIndex, repeat = false) =>
          shouldHandlePress(`btn-${buttonIndex}`, isPressed(buttonIndex), repeat);

        if (controllerNeedsInteractionRef.current && hasAnyInput()) {
          controllerNeedsInteractionRef.current = false;
          setControllerNeedsInteraction(false);
          gamepadRepeatStateRef.current = {};
          gamepadRafRef.current = requestAnimationFrame(runControllerLoop);
          return;
        }

        if (!emulationModalOpenRef.current && !controllerNeedsInteractionRef.current) {
          if (shouldHandleButton(0) && selectedGameRef.current && !launchingGameRef.current && romPathRef.current) {
            playControllerSound('confirm');
            playSelectedGameRef.current?.();
          }
          if (backJustPressed) {
            playControllerSound('back');
            navigateRef.current?.();
          }
          if (viewToggleRef.current) {
            if (shouldHandleButton(6, true)) {
              selectNextGameFromControllerRef.current?.(-10);
            }
            if (shouldHandleButton(7, true)) {
              selectNextGameFromControllerRef.current?.(10);
            }
          }
          if (shouldHandleButton(3) && selectedGameRef.current) {
            playControllerSound('confirm');
            toggleFavoriteRef.current?.(selectedGameRef.current.id);
          }
          if (shouldHandleButton(9)) {
            playControllerSound('confirm');
            const currentGames = gamesRef.current || [];
            if (currentGames.length) {
              const index = Math.floor(Math.random() * currentGames.length);
              const nextGame = currentGames[index];
              if (nextGame) {
                setSelectedGame(nextGame);
                if (isMobileRef.current) {
                  setMobileModalOpen(true);
                }
              }
            }
          }
          if (shouldHandleButton(14, true)) {
            selectNextGameFromControllerRef.current?.(-1);
          }
          if (shouldHandleButton(15, true)) {
            selectNextGameFromControllerRef.current?.(1);
          }
          if (!viewToggleRef.current) {
            if (shouldHandleButton(12, true)) {
              selectNextGameFromControllerRef.current?.(-getGridStepSize());
            }
            if (shouldHandleButton(13, true)) {
              selectNextGameFromControllerRef.current?.(getGridStepSize());
            }
          }
        }
      } else {
        gamepadRepeatStateRef.current = {};
      }

      gamepadRafRef.current = requestAnimationFrame(runControllerLoop);
    };

    const onGamepadConnect = () => updateGamepadConnection(getPrimaryGamepad());
    const onGamepadDisconnect = () => updateGamepadConnection(getPrimaryGamepad());

    window.addEventListener('gamepadconnected', onGamepadConnect);
    window.addEventListener('gamepaddisconnected', onGamepadDisconnect);
    gamepadRafRef.current = requestAnimationFrame(runControllerLoop);

    return () => {
      window.removeEventListener('gamepadconnected', onGamepadConnect);
      window.removeEventListener('gamepaddisconnected', onGamepadDisconnect);
      if (gamepadRafRef.current) {
        cancelAnimationFrame(gamepadRafRef.current);
      }
    };
  }, [playControllerSound]);

  useEffect(() => {
    if (previousGamepadConnectedRef.current === null) {
      previousGamepadConnectedRef.current = gamepadConnected;
      if (gamepadConnected) {
        sessionStorage.setItem(CONTROLLER_CONNECTED_STATE_KEY, '1');
      } else {
        sessionStorage.removeItem(CONTROLLER_CONNECTED_STATE_KEY);
      }
      return;
    }
    if (previousGamepadConnectedRef.current === gamepadConnected) {
      return;
    }
    const justConnected = !previousGamepadConnectedRef.current && gamepadConnected;
    if (justConnected && filteredGames.length > 0) {
      selectedGameIndexRef.current = 0;
      if (viewToggle && page !== 0) {
        controllerPageChangePendingRef.current = true;
        setPage(0);
      }
      setSelectedGame(filteredGames[0]);
    }
    if (gamepadConnected) {
      showControllerToast(`🎮 ${gamepadName || 'Controller'} connected`);
      sessionStorage.setItem(CONTROLLER_CONNECTED_STATE_KEY, '1');
    } else {
      showControllerToast('🎮 Controller disconnected');
      sessionStorage.removeItem(CONTROLLER_CONNECTED_STATE_KEY);
    }
    previousGamepadConnectedRef.current = gamepadConnected;
  }, [filteredGames, gamepadConnected, gamepadName, page, showControllerToast, viewToggle]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        window.focus();
        if (sessionStorage.getItem(RETURN_FROM_LAUNCH_FOCUS_KEY) === '1') {
          sessionStorage.removeItem(RETURN_FROM_LAUNCH_FOCUS_KEY);
          setControllerNeedsInteraction(false);
          return;
        }
        if (gamepadConnected && !isMobile) {
          setControllerNeedsInteraction(true);
        }
      }
    };

    const handleWindowBlur = () => {
      if (sessionStorage.getItem(RETURN_FROM_LAUNCH_FOCUS_KEY) === '1') {
        return;
      }
      if (gamepadConnected && !isMobile) {
        setControllerNeedsInteraction(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('blur', handleWindowBlur);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('blur', handleWindowBlur);
    };
  }, [gamepadConnected, isMobile]);

  useEffect(() => {
    if (!controllerNeedsInteraction) return;

    const rearmController = () => {
      setControllerNeedsInteraction(false);
      window.focus();
    };

    window.addEventListener('pointerdown', rearmController);
    window.addEventListener('keydown', rearmController);

    return () => {
      window.removeEventListener('pointerdown', rearmController);
      window.removeEventListener('keydown', rearmController);
    };
  }, [controllerNeedsInteraction]);

  useEffect(() => {
    if (!selectedGame || isMobile) return;
    const pageChangedFromController = controllerPageChangePendingRef.current;
    const useSnappyLargeListMode = filteredGames.length > LARGE_LIST_SNAPPY_THRESHOLD;
    controllerPageChangePendingRef.current = false;
    controllerSelectionMovePendingRef.current = false;
    scrollGameIntoView(
      selectedGame.id,
      viewToggle && pageChangedFromController && !useSnappyLargeListMode ? 120 : 0
    );
  }, [selectedGame, viewToggle, page, isMobile, filteredGames.length, scrollGameIntoView]);
  
  
  useEffect(() => {
    if (!selectedGame || !wrapperRef.current || !contentRef.current) return;
  
    const wrapper = wrapperRef.current;
    const content = contentRef.current;
  
    const scrollAmount = content.scrollHeight - wrapper.clientHeight;
  
    if (scrollAmount > 0) {
      content.style.setProperty('--scroll-distance', `-${scrollAmount}px`);
      content.style.animation = 'none';
  
      const startScroll = () => {
        content.style.animation = 'scrollDescription 20s linear forwards';
      };
  
      const delayTimer = setTimeout(startScroll, 5000); // 5-second delay
  
      const resetTimer = setInterval(() => {
        content.style.animation = 'none';
        void content.offsetHeight; // force reflow
        setTimeout(startScroll, 5000); // delay again after reset
      }, 30000); // every 30 seconds
  
      return () => {
        clearTimeout(delayTimer);
        clearInterval(resetTimer);
      };
    } else {
      content.style.animation = 'none';
    }
  }, [selectedGame]);
  

  const columns = [
    { field: 'title', headerName: 'Title', width: isMobile ? 210 : 400 },
    { field: 'platform_name', headerName: 'Platform', width: isMobile ? 180 : 200 },
    { field: 'release_year', headerName: 'Year', width: isMobile ? 60 : 100 },
  
    // On mobile, keep these columns visible but super narrow
    { field: 'developer', headerName: 'Developer', width: isMobile ? 150 : 200 },
    { field: 'region', headerName: 'Region', width: isMobile ? 100 : 200 },
    { field: 'completed', headerName: 'Completed', width: isMobile ? 50 : 120 },
    { field: 'genres', headerName: 'Genres', width: isMobile ? 150 : 200 },
    { field: 'date_added', headerName: 'Added', width: isMobile ? 90 : 150 },
  ];

  return (
    <>
      {showEntryWhiteOverlay && (
        <>
          <Box
            className={`whiteFade${entryWhiteOverlayFadeOut ? ' fadeOut' : ''}`}
            sx={{
              position: 'fixed',
              inset: 0,
              zIndex: 4000,
              pointerEvents: 'none',
            }}
          />
          <Box
            component="img"
            src={loadingSprite.image}
            alt=""
            aria-hidden
            sx={{
              position: 'fixed',
              left: 0,
              top: '50%',
              zIndex: 4001,
              width: `${loadingSprite.sizePx}px`,
              height: `${loadingSprite.sizePx}px`,
              display: 'block',
              objectFit: 'contain',
              pointerEvents: 'none',
              imageRendering: 'pixelated',
              opacity: entryWhiteOverlayFadeOut ? 0 : 0.82,
              transition: 'opacity 320ms ease',
              animation: `loadingSpriteWalk ${loadingSprite.durationSeconds}s linear forwards`,
              '@keyframes loadingSpriteWalk': {
                from: { transform: 'translate(-14vw, -50%)' },
                to: { transform: 'translate(128vw, -50%)' },
              },
            }}
          />
        </>
      )}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.18), rgba(255,255,255,0.04) 40%, rgba(0,0,0,0.18) 100%)',
          opacity: 0,
          pointerEvents: 'none',
          transition: 'none',
          zIndex: 0,
        }}
      />

      {/* Main content */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 3,
          p: 2,
          flexWrap: 'nowrap',
        }}
      >
        {/* Games Table */}
        <Box sx={{ flexGrow: 1, width: isMobile ? '95%' : 200}}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 2 }}>
          <TextField
            label="Search games..."
            variant="outlined"
            fullWidth
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onBlur={() => {
              // When user clicks out of input, update term to trigger search
              setTerm(search);
            }}
          />
          <button className="snazzy-button full-size transparent"onClick={toggle}>
        {viewToggle ? 'Grid' : 'List'}
      </button>

              {locked && (
                <button className="snazzy-button full-size transparent" onClick={handleUnlock} aria-label="Unlock">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    backgroundColor="transparent"
                    viewBox="0 0 16 16"
                  >
                    <path d="M8 1a3 3 0 0 0-3 3v3H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-1V4a3 3 0 0 0-3-3zM6 4a2 2 0 1 1 4 0v3H6V4z"/>
                  </svg>
                </button>
              )}
              <button className="snazzy-button full-size transparent" onClick={randomGame} aria-label="Unlock">
                  <img className="small-img" src="https://media.tenor.com/WiTP5aZyPLUAAAAj/dice-roll-dice.gif" alt="Dice"></img>
                </button>
            <Box>
            {!locked && (
              <button
                className="snazzy-button full-size"
                onClick={() => {
                    setSelectedGame(null);
                    setEditForm({
                    platform_id: platformId,
                    title: '',
                    release_year: null,
                    developer: '',
                    publisher: '',
                    region: '',
                    description: '',
                    completed: false,
                    condition: '',
                  });
                  setUploadFile(null);
                  setEditOpen(true);
                }}
              >
                +
              </button>
            )}
            </Box>
        </Box>
        <div style={{ width: '100%', overflowX: 'auto' }}>
        <div style={{ minWidth: '100%' }}> {/* Optional: ensure a minimum readable width */}
        {viewToggle ? (
        <DataGrid
        rows={filteredGames}
        columns={columns}
        getRowId={(row) => row.id}
        rowSelectionModel={{
          type: 'include',
          ids: new Set(selectedGame ? [selectedGame.id] : []),
        }}
        disableRowSelectionOnClick
        getRowClassName={(params) => (params.id === selectedGame?.id ? 'selected-game-row' : '')}
        autoHeight
        pagination
        paginationModel={{ pageSize, page }}
        onPaginationModelChange={(model) => {
            if (model.page !== page) {
              setPage(model.page);
            }
            if (model.pageSize !== pageSize) {
              setPageSize(model.pageSize);
            }
        }}
        pageSizeOptions={[10, 25, 50, 100]}
        onRowClick={(params) => {
            const rowBoxArtUrl = getCachedBoxArtUrl(params.row);
            if (rowBoxArtUrl) {
              setBoxArtUrl(rowBoxArtUrl);
            }
            setShowAddList(false);
            setSelectedGame(params.row);
            if (isMobile) {
              setMobileModalOpen(true);
            }
        }}
        sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            borderRadius: 2,
            '& .MuiDataGrid-columnHeaders': {
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            fontWeight: 'bold',
            },
            '& .MuiDataGrid-cell': {
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            },
            '& .selected-game-row, & .selected-game-row .MuiDataGrid-cell': {
            backgroundColor: 'rgba(74, 144, 226, 0.35) !important',
            },
            width: isMobile ? tableWidth : 1920,    // smaller width on mobile, wider on desktop
             maxWidth: '100%',                   // prevent overflow
        }}
        /> 
        ) : (
         
          <GridView
            games={filteredGames}
            selectedGame={selectedGame}
            setSelectedGame={setSelectedGame}
            isMobile={isMobile}
            setMobileModalOpen={setMobileModalOpen}
            setBoxArtUrl={setBoxArtUrl}
            getCachedBoxArtUrl={getCachedBoxArtUrl}
            normalizeBoxArtUrl={normalizeBoxArtUrl}
            fallbackBoxArtUrl={fallbackBoxArtUrl}
            controllerHighlightActive={gamepadConnected && !controllerNeedsInteraction && !isMobile}
            onGridGameSelect={(game, imageUrl) => {
              const resolvedUrl = normalizeBoxArtUrl(imageUrl);
              if (resolvedUrl) {
                boxArtCacheRef.current[game.id] = resolvedUrl;
                setBoxArtUrl(resolvedUrl);
              }
              setSelectedGame(game);
              if (isMobile) {
                setMobileModalOpen(true);
              }
            }}
          />
        
        )}
          </div>
        </div>
        </Box>

        {/* Game Details Sidebar - desktop */}
        {!isNarrow ? (
        <Box
          component={Paper}
          elevation={3}
          sx={{
            boxSizing: 'border-box',
            width: 300,
            minWidth: 300,
            maxWidth: 300,
            p: 2,
            flex: '0 0 300px',
            bgcolor: 'rgba(255,255,255,.3)',
            color: 'black',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            position: 'sticky',
            transition: 'top 0.3s ease',
            top: 16,
            maxHeight: 'calc(100vh - 32px)',
            overflowX: 'hidden',
            overflowY: 'auto',
          }}
        >
          {!selectedGame ? (
            <Typography
              variant="body2"
              color="text.secondary"
              fontStyle="italic"
              textAlign="center"
            >
              Click a game to see details
            </Typography>
          ) : (
            <>
                  <Box
                    component="img"
                    src={getConsoleLogoPath(selectedGame.platform_name)}
                    alt={`Console logo`}
                    sx={{ width: 'min(150px, 100%)', alignSelf: 'center', paddingBottom: 1 }}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/assets/console-logos/default.png';
                    }}
                    />
              {loadingBoxArt ? (
                <CircularProgress sx={{ mb: 2 }} />
              ) : boxArtUrl ? (
                <Box
                  component="img"
                  src={boxArtUrl}
                  alt={`${selectedGame.title} box art`}
                  onError={(e) => {
                    if (fallbackBoxArtUrl && e.target.src !== fallbackBoxArtUrl) {
                      e.target.onerror = null;
                      e.target.src = fallbackBoxArtUrl;
                    }
                  }}
                  sx={{
                    maxWidth: '100%',
                    maxHeight: 300,
                    alignSelf: 'center',
                    mb: 2,
                    borderRadius: 1,
                    boxShadow: 3,
                    objectFit: 'contain',
                  }}
                />
              ) : (
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ mb: 2 }}
                  textAlign="center"
                >
                  No box art found
                </Typography>
              )}

              <Typography variant="h5" textAlign="center" sx={{ overflowWrap: 'anywhere' }}>
                {selectedGame.title}
              </Typography>
              <span
                className="material-icons"
                style={{ cursor: "pointer", color: isFavorite ? "gold" : "gray", fontSize:30, 
                  textShadow: isFavorite ? "1px 1px 2px rgba(0,0,0,0.5)" : "none" }}
                onClick={() => toggleFavorite(selectedGame.id)}
              >
                {isFavorite ? ' ★' : ' ☆'}
              </span>
              <Typography sx={{ overflowWrap: 'anywhere' }}>
              <strong>Platform:</strong>{' '}
              {selectedGame.platform_name || 'N/A'}
              </Typography>
              <Typography sx={{ overflowWrap: 'anywhere' }}>
                <strong>Release Year:</strong>{' '}
                {selectedGame.release_year || 'N/A'}
              </Typography>
              <Typography sx={{ overflowWrap: 'anywhere' }}>
                <strong>Developer:</strong>{' '}
                {selectedGame.developer || 'Unknown'}
              </Typography>
              <Typography sx={{ overflowWrap: 'anywhere' }}>
                <strong>Publisher:</strong>{' '}
                {selectedGame.publisher || 'Unknown'}
              </Typography>
              <Typography sx={{ overflowWrap: 'anywhere' }}>
                <strong>Region:</strong> {selectedGame.region || 'N/A'}
              </Typography>
             <Typography>
              <strong>Condition:</strong> {formatCondition(selectedGame.condition)}
            </Typography>
              <Typography component="div" sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
              <strong>Completed:</strong>{' '}
              {selectedGame.completed}
              <Tooltip title="Toggle Completed">
                <IconButton
                  size="small"
                  onClick={toggleCompleted}
                >
                  {selectedGame.completed === 'Yes' ? (
                    <CheckCircleIcon fontSize="small" color="success" />
                  ) : (
                    <CancelIcon fontSize="small" color="disabled" />
                  )}
                </IconButton>
              </Tooltip>
            </Typography>

            {renderEmulationControls()}

           {/* Genre Chips + Add Button */}
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    justifyContent: 'center',
                    mb: 2,
                    minWidth: 0,
                    maxWidth: '100%',
                  }}
                >
                  {genres.map((genre) => (
                    <Chip
                      key={genre.id}
                      label={genre.name}
                      size="small"
                      variant="outlined"
                      sx={{ fontWeight: 500, cursor: 'pointer' }}
                      onClick={() => removeGenre(genre.id)}
                    />
                  ))}
                  {!locked && (<Chip
                    label="+"
                    size="small"
                    variant="outlined"
                    sx={{ fontWeight: 500, cursor: 'pointer' }}
                    onClick={fetchAddableGenres}
                  />
                  )}
                </Box>
                

              {/* Addable Genre List */}
              {showAddList && (
                <Box
                  sx={{
                    mt: 1,
                    p: 1,
                    border: '0px solid #ccc',
                    borderRadius: 5,
                    maxHeight: 150,
                    width: '100%',
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    overflowY: 'auto',
                    backgroundColor: 'rgba(255,255,255,0.3)',
                    marginBottom:2,
                                      }}
                >
                  {addableGenres.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                      No genres available to add
                    </Typography>
                  ) : (
                    addableGenres.map((genre) => (
                      <Chip
                        key={genre.id}
                        label={genre.name}
                        size="small"
                        variant="outlined"
                        sx={{ m: 0.5, cursor: 'pointer' }}
                        onClick={() => handleAddGenre(genre.id)}
                      />
                    ))
                  )}
                </Box>
              )}


              <Typography component="div">
              {!locked && selectedGame && (
                  <Box sx={{ width: '100%', mb: 2, textAlign: 'right' }}>
                    <button className="snazzy-button" onClick={() => {
                    setEditForm({
                      ...selectedGame,
                      platform_id: platformId, // <-- ensure this is set
                    });
                    setUploadFile(null);
                    setEditOpen(true);
                    }}>
                    Edit
                    </button>
                </Box>
                )}
                </Typography>

              <div className="scroll-wrapper" ref={wrapperRef}>
                <div className="scroll-content" ref={contentRef}>
                    <Typography
                    variant="body2"
                    sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', fontSize: '0.9rem' }}
                    >
                    {selectedGame.description || 'No description available.'}
                    </Typography>
                </div>
                </div>
            </>
          )}
        </Box>
        ) : (false)}
      </Box>
      {editOpen && (
  <Box
    sx={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}
    ModalProps={{
      BackdropProps: {
        sx: {
          zIndex: 1500,  // higher than game modal backdrop
        },
      },
      sx: {
        zIndex: 1500,    // higher than game modal container
      },
    }}
    onClick={() => setEditOpen(false)} // close if clicking outside modal content
  >
<Box
      onClick={e => e.stopPropagation()}
      sx={{
        bgcolor: 'background.paper',
        p: 3,
        boxSizing: 'border-box',
        borderRadius: 2,
        maxWidth: !isMobile ? 800 : 500,
        width: 'min(90vw, 800px)',
        maxHeight: '90vh',
        overflowY: 'auto',
        zIndex:1400,
      }}
    >
      <Typography variant="h6" mb={2}>
        {editForm.id ? 'Edit Game' : 'Add New Game'}
      </Typography>

      <form onSubmit={async (e) => {
  e.preventDefault();
  setSaving(true);

  const formData = new FormData();
  Object.entries(editForm).forEach(([key, val]) => {
    if (key !== "box_art_url" && val !== null && val !== undefined && val !== "null") {
      formData.append(key, val);
    }
  });

  if (uploadFile instanceof File) {
    formData.append('box_art', uploadFile);
  } else if (editForm.box_art_url && !editForm.box_art_url.startsWith('blob:')) {
    formData.append('injected_url', editForm.box_art_url);
  }

  try {
    await axios.post(`${REACT_APP_API_URL}/game/edit`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });

    const res = await axios.get(`${REACT_APP_API_URL}/platforms/${platformId}/games`);
    setGames(res.data);
    setFilteredGames(res.data);
    setSelectedGame(null);
    setBoxArtUrl(null);
    setEditOpen(false);
  } catch (err) {
    alert('Error saving game: ' + err.message);
  } finally {
    setSaving(false);
  }
}}>
  
  {/* --- DYNAMIC SIDE-BY-SIDE GRID CONTAINER --- */}
  <Box 
    sx={{ 
      display: 'flex', 
      flexDirection: !isMobile ? 'row' : 'column', 
      gap: 3,
      alignItems: 'flex-start'
    }}
  >
    {/* Left Column: Form Fields */}
    <Box sx={{ flex: 1, width: '100%' }}>
      <TextField
        label="Title"
        fullWidth
        margin="normal"
        value={editForm.title || ''}
        onChange={e => setEditForm({...editForm, title: e.target.value})}
        required
      />
      <input type="hidden" name="platform_id" value={editForm.platform_id || platformId} />
      <TextField
        label="Release Year"
        type="number"
        fullWidth
        margin="normal"
        value={editForm.release_year || ''}
        onChange={e => setEditForm({...editForm, release_year: e.target.value})}
      />
      <TextField
        label="Developer"
        fullWidth
        margin="normal"
        value={editForm.developer || ''}
        onChange={e => setEditForm({...editForm, developer: e.target.value})}
      />
      <TextField
        label="Publisher"
        fullWidth
        margin="normal"
        value={editForm.publisher || ''}
        onChange={e => setEditForm({...editForm, publisher: e.target.value})}
      />
      <FormControl fullWidth margin="normal">
        <InputLabel id="region-label">Region</InputLabel>
        <Select
          labelId="region-label"
          value={editForm.region || ''}
          label="Region"
          onChange={e => setEditForm({ ...editForm, region: e.target.value })}
        >
          <MenuItem value="North America">North America</MenuItem>
          <MenuItem value="Europe">Europe</MenuItem>
          <MenuItem value="Japan">Japan</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal">
        <InputLabel id="condition-label">Condition</InputLabel>
        <Select
          labelId="condition-label"
          value={editForm.condition || ''}
          label="Condition"
          onChange={e => setEditForm({ ...editForm, condition: e.target.value })}
        >
          <MenuItem value="LOOSE">Loose</MenuItem>
          <MenuItem value="COMPLETE">Complete</MenuItem>
          <MenuItem value="SEALED">Sealed</MenuItem>
          <MenuItem value="JUNK">Junk</MenuItem>
        </Select>
      </FormControl>
      <TextField
        label="Rank Score"
        fullWidth
        margin="normal"
        value={editForm.grade || ''}
        onChange={e => setEditForm({...editForm, grade: e.target.value})}
      />
      <TextField
        label="Description"
        multiline
        rows={3}
        fullWidth
        margin="normal"
        value={editForm.description || ''}
        onChange={e => setEditForm({...editForm, description: e.target.value})}
      />
    </Box>

    {/* Right Column: Box art layout preview configuration */}
    <Box 
      sx={{ 
        width: !isMobile ? '240px' : '100%', 
        position: !isMobile ? 'sticky' : 'static',
        top: 0,
        mt: 2 
      }}
    >
      <label htmlFor="box-art-upload" style={{ fontWeight: 'bold' }}>Upload Box Art (optional):</label><br/>
      <input
        type="file"
        id="box-art-upload"
        accept="image/*"
        style={{ marginTop: '8px', marginBottom: '8px' }}
        onChange={e => {
          const file = e.target.files[0];
          setUploadFile(file);
          if (file) {
            setEditForm(prev => ({ ...prev, box_art_url: URL.createObjectURL(file) }));
          }
        }}
      />
      {uploadFile && <Typography variant="caption" display="block" sx={{ mb: 1 }}>{uploadFile.name}</Typography>}

      {editForm?.box_art_url && (
        <Box sx={{ mt: 2, textAlign: 'center' }}>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
            Current Image Preview:
          </Typography>
          <Box
            component="img"
            src={editForm.box_art_url}
            alt="Box Art Preview"
            onError={(e) => {
              if (fallbackBoxArtUrl && e.target.src !== fallbackBoxArtUrl) {
                e.target.onerror = null;
                e.target.src = fallbackBoxArtUrl;
              }
            }}
            sx={{
              maxWidth: '100%',
              maxHeight: !isMobile ? 320 : 180, 
              borderRadius: 2,
              boxShadow: 2,
              objectFit: 'contain',
              border: '1px solid rgba(0,0,0,0.1)'
            }}
          />
        </Box>
      )}
  </Box>
  </Box>

  {/* Action Buttons Footer */}
  <Box sx={{
    mt: 3,
    pt: 2,
    borderTop: '1px solid rgba(0,0,0,0.05)',
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr) auto',
    gridTemplateAreas: '"cancel tools save"',
    alignItems: 'center',
    gap: 1,
    '@media (max-width: 600px)': {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      gridTemplateAreas: '"tools tools" "cancel save"',
    },
    '& > .game-edit-footer-button': { width: '100%', minWidth: 0 },
  }}>
    <button className="snazzy-button game-edit-footer-button" style={{ gridArea: 'cancel' }} type="button" onClick={() => setEditOpen(false)} disabled={saving}>
      Cancel
    </button>
    
    <Box className="game-edit-action-tools" sx={{
      gridArea: 'tools',
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      alignItems: 'stretch',
      gap: 1,
      minWidth: 0,
      '@media (max-width: 600px)': {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      },
      '& .snazzy-button': {
        width: '100%',
        minWidth: 0,
        minHeight: 44,
        height: 'auto',
        borderRadius: 2,
        letterSpacing: '0.04em',
        overflowWrap: 'anywhere',
      },
      '& > .game-edit-vision-action': { display: 'flex', minWidth: 0 },
      '& > .game-edit-vision-action label': { display: 'flex', width: '100%' },
      '& > .game-edit-igdb-action': {
        gridColumn: isMobile ? '1 / -1' : 'auto',
      },
    }}>
      
      {editForm?.id && (
        <button
          type="button"
          className="snazzy-button"
          onClick={handleUpdateBoxArtFromSteamGrid}
          disabled={scanning || saving}
        >
          🖼️ SteamGrid Art
        </button>
      )}

      <Box className="game-edit-vision-action">
        <input
          type="file"
          accept="image/*"
          capture="environment"
          id="vision-camera-upload"
          style={{ display: 'none' }}
          onChange={handleVisionScan}
          disabled={scanning || saving}
        />
        <label htmlFor="vision-camera-upload">
          <button
            type="button"
            className="snazzy-button"
            style={{ backgroundColor: '#4caf50', width: '100%' }}
            onClick={() => document.getElementById('vision-camera-upload').click()}
            disabled={scanning || saving}
          >
            {scanning ? '📸 Scanning...' : '📸 Scan Cover (AI)'}
          </button>
        </label>
      </Box>

      <button
        type="button"
        className="snazzy-button game-edit-igdb-action"
        disabled={scanning || saving || igdbLoading}
        onClick={handleIgdbAutofill}
      >
        {igdbLoading ? 'Searching IGDB...' : '🖥️ Autofill from IGDB'}
      </button>
    </Box>
    
    <button className="snazzy-button game-edit-footer-button" style={{ gridArea: 'save' }} type="submit" disabled={saving}>
      {saving ? 'Saving...' : 'Save'}
    </button>
  </Box>
</form>
    </Box>
  </Box>
)}

<Dialog
  open={igdbDialogOpen}
  onClose={() => setIgdbDialogOpen(false)}
  fullWidth
  maxWidth="sm"
>
  <DialogTitle>
    Choose an IGDB match{igdbPlatformName ? ` for ${igdbPlatformName}` : ''}
  </DialogTitle>
  <DialogContent dividers>
    <Typography variant="body2" sx={{ mb: 1 }}>
      Select a game to fill the form. Only title-prefix matches for this console are shown.
    </Typography>
    <List disablePadding>
      {igdbCandidates.map((game, index) => (
        <ListItemButton
          key={game.igdb_id || `${game.title}-${index}`}
          onClick={() => applyIgdbGame(game)}
          divider
        >
          <ListItemText
            primary={`${game.title || 'Untitled game'}${game.release_year ? ` (${game.release_year})` : ''}`}
            secondary={game.platforms?.join(', ') || 'Platform not listed'}
          />
        </ListItemButton>
      ))}
    </List>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setIgdbDialogOpen(false)}>Cancel</Button>
  </DialogActions>
</Dialog>

{isMobile && selectedGame && (
  <Dialog
    open={mobileModalOpen}
    onClose={() => setMobileModalOpen(false)}
    ModalProps={{
      BackdropProps: {
        sx: {
          zIndex: 1400,
        },
      },
      sx: {
        zIndex: 1400,
      },
    }}
    PaperProps={{
      sx: {
        backgroundImage: boxArtUrl
          ? `linear-gradient(rgba(255,255,255,0.82), rgba(255,255,255,0.82)), url(${boxArtUrl})`
          : undefined,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backdropFilter: 'blur(40px)',
        WebkitBackdropFilter: 'blur(40px)',
        borderRadius: 3,
        overflow: 'hidden',
      },
    }}
>

<IconButton
        edge="end"
        color="inherit"
        onClick={() => setMobileModalOpen(false)}
        aria-label="close"
        sx={{ position: 'absolute', right: 8, top: 0 }}
      >
        <CloseIcon />
      </IconButton>
    <DialogContent dividers
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    }}>
      <Box
                    component="img"
                    src={getConsoleLogoPath(selectedGame.platform_name)}
                    alt={`Console logo`}
                    sx={{width: 150, paddingBottom:1}}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/assets/console-logos/default.png';
                    }}
                    />
    
      {/* etc... */}

      {/* Box art */}
      {loadingBoxArt ? (
        <CircularProgress sx={{ mb: 2 }} />
      ) : boxArtUrl ? (
        <Box
          component="img"
          src={boxArtUrl}
          alt={`${selectedGame.title} box art`}
          sx={{
            maxWidth: '100%',
            maxHeight: 300,
            mb: 2,
            borderRadius: 4,
            boxShadow: 5,
            objectFit: 'contain',
          }}
        />
      ) : (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 2 }}>
          No box art found
        </Typography>
      )}
      <div className="center-text">
        <Typography sx={{fontSize:20}}>
       <strong> {selectedGame.title} </strong>
       <span
                className="material-icons"
                style={{ cursor: "pointer", color: isFavorite ? "gold" : "gray", fontSize:20, 
                  textShadow: isFavorite ? "1px 1px 2px rgba(0,0,0,0.5)" : "none" }}
                onClick={() => toggleFavorite(selectedGame.id)}
              >
                {isFavorite ? ' ★' : ' ☆'}
              </span>
      </Typography>
    
       <Typography><strong>Release Year:</strong> {selectedGame.release_year || 'N/A'}</Typography>
       <Typography><strong>Developer:</strong> {selectedGame.developer || 'N/A'}</Typography>
       <Typography><strong>Publisher:</strong> {selectedGame.publisher || 'N/A'}</Typography>
       <Typography><strong>Region:</strong> {selectedGame.region || 'N/A'}</Typography>
       <Typography>
        <strong>Condition:</strong> {formatCondition(selectedGame.condition)}
      </Typography>
       
      {/* Completed toggle button */}
      <Box sx={{ gap: 1, mb: 1 }}>
        <strong>Completed:</strong> {selectedGame.completed}
        <Tooltip title="Toggle Completed">
          <IconButton size="small" onClick={toggleCompleted}>
            {selectedGame.completed === 'Yes' ? (
              <CheckCircleIcon fontSize="small" color="success" />
            ) : (
              <CancelIcon fontSize="small" color="disabled" />
            )}
          </IconButton>
        </Tooltip>
      </Box>

      {renderEmulationControls()}
      </div>
      {/* Genre Chips + Add Button */}
      <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1,
                    justifyContent: 'center',
                    mb: 2,
                  }}
                >
                  {genres.map((genre) => (
                    <Chip
                      key={genre.id}
                      label={genre.name}
                      size="small"
                      variant="outlined"
                      sx={{ fontWeight: 500, cursor: 'pointer' }}
                      onClick={() => removeGenre(genre.id)}
                    />
                  ))}
                  {!locked && (<Chip
                    label="+"
                    size="small"
                    variant="outlined"
                    sx={{ fontWeight: 500, cursor: 'pointer' }}
                    onClick={fetchAddableGenres}
                  />
                  )}
                </Box>
                

              {/* Addable Genre List */}
              {showAddList && (
                <Box
                  sx={{
                    mt: 1,
                    p: 1,
                    border: '0px solid #ccc',
                    borderRadius: 5,
                    maxHeight: 250,
                    width: 350,
                    backgroundColor: 'rgba(255,255,255,0.3)',
                    marginBottom:2,
                                      }}
                >
                  {addableGenres.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                      No genres available to add
                    </Typography>
                  ) : (
                    addableGenres.map((genre) => (
                      <Chip
                        key={genre.id}
                        label={genre.name}
                        size="small"
                        variant="outlined"
                        sx={{ m: 0.5, cursor: 'pointer' }}
                        onClick={() => handleAddGenre(genre.id)}
                      />
                    ))
                  )}
                </Box>
              )}

      <Typography component="div">
              {!locked && selectedGame && (
                  <Box sx={{ width: '100%', mb: 2, textAlign: 'right' }}>
                    <button className="snazzy-button" onClick={() => {
                    setEditForm({
                      ...selectedGame,
                      platform_id: platformId, // <-- ensure this is set
                    });
                    setUploadFile(null);
                    setMobileModalOpen(false);
                    setEditOpen(true);
                    }}>
                    Edit
                    </button>
                </Box>
                )}
                </Typography>

      {/* Description */}
      <Typography sx={{ whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}>
        {selectedGame.description || 'No description available.'}
      </Typography>
      
    </DialogContent>
  </Dialog>
)}
      {controllerToast.open && (
        <Box
          sx={{
            position: 'fixed',
            left: 16,
            bottom: 16,
            zIndex: 5000,
            bgcolor: 'rgba(20,20,20,0.9)',
            color: '#fff',
            px: 2,
            py: 1.2,
            borderRadius: 2,
            boxShadow: 6,
            fontWeight: 700,
            pointerEvents: 'none',
            animation: 'controller-toast-rise-out 2200ms ease forwards',
          }}
        >
          {controllerToast.message}
        </Box>
      )}
    </>
    
  );

  
}

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
}

function usePageWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);

    // cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
}